import { ChangeDetectorRef, Component, HostListener, OnInit, OnDestroy, ViewChild, TemplateRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from 'src/app/shared/globals/globals';
import { BackendService } from 'src/app/shared/services/backend/backend.service';
import { TeiasoftLoaderService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-loader.service';
import { DialogButton, DialogForm, DialogList, DialogObject, DialogSelect } from 'src/app/shared/teiasoft-bucket/teiasoft-dialog/teiasoft-dialog.component';
import { ActiveFilter, CalculatedCols, CellSpecialStyle, ColumnWidth, CustomIcoCol, GridColumn, GridConfiguration, MenuVoice, OdataGridInitialFilters } from 'src/app/shared/teiasoft-bucket/teiasoft-grid-odata/teiasoft-grid-odata.component';
import { SelectOption } from 'src/app/shared/teiasoft-bucket/teiasoft-select/teiasoft-select.component';
import { TTButton } from 'src/app/shared/teiasoft-bucket/teiasoft-toolbar/teiasoft-toolbar.component';
import { TeiasoftToasterService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-toaster.service';
import { TeiasoftModalService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-modal.service';
import { BonusScheme, HeaderParametersValues, MarketFamily, OfferScheme, SalesOfficePerson, UomsType } from 'src/app/shared/models/data/headerParametersValues.model';
import { CreateEnquiry, CreateEnquiryCustomer } from 'src/app/shared/models/data/createEnquiry.model';
import { Autocomplete } from 'src/app/shared/teiasoft-bucket/teiasoft-input/teiasoft-input.component';
import { AttachmentToUpdate, CustomerSpecialRequirement, Enquiry, EnquiryAttachment, EnquiryHeader, EnquiryHeaderItem, EnquiyNormGrade } from 'src/app/shared/models/data/enquiry.model';
import { TeiasoftModalReturnObject } from 'src/app/shared/teiasoft-bucket/teiasoft-modal/teiasoft-modal.component';
import { NormGrade } from 'src/app/shared/models/data/normGrades.model';
import { NpsAndSchedule } from 'src/app/shared/models/data/npsAndSchedules.model';
import { CloseEnquiryData } from './close-enquiry/close-enquiry.component';
import { EnquiryByEnquiryNo } from 'src/app/shared/models/data/enquiryByEnquiryNo.model';
import { ItemAttachment, Items, ItemsByEnquiryNo } from 'src/app/shared/models/data/itemsByEnquiryNo.model';
import { ClickedCell, GridDataset } from 'src/app/shared/teiasoft-bucket/teiasoft-grid/teiasoft-grid.component';
import { ItemParametersValues } from 'src/app/shared/models/data/itemParametersValues.model';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { RawMaterialGrade } from 'src/app/shared/models/data/rawMaterialGrades.model';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { RoundDigit } from 'src/app/shared/models/data/roundDigit.model';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { QuotationConfigurationAndPdf } from 'src/app/shared/models/data/quotationData';
import { FreezeEnquiry } from 'src/app/shared/models/data/freezeEnquiry.model';
import { OpenItdcrEvent } from 'src/app/shared/models/app/openItdcr.model';
import { RevisionSavePayload } from './modal-revision/modal-revision.component';
import { EnquiryTotalPriceAndMargin } from 'src/app/shared/models/data/enquiryTotalPriceAndMargin.model';
import { parseGridActionEvent } from 'src/app/shared/utils/grid-event.utils';
declare var $: any;

@Component({
  selector: 'app-enquiry-book',
  templateUrl: './enquiry-book.component.html',
  styleUrls: ['./enquiry-book.component.scss']
})
export class EnquiryBookComponent implements OnInit, OnDestroy {


  // MP: columnsToHide should be removed due to MQF-236: i've tried but looks like it's breaking the odata table
  columnsToHide: string[] = ['Id', "DueDateColor", "UserId", "SalesOfficeId", 'CostsStatus', 'FeasibilityStatus', 'DeliveryStatus', 'QuotationExists', 'IsQuotationFinal', 'IsQuotationExternallyUploaded', 'OdUom', 'IdUom', 'WtUom', 'TotalWeightUom', 'BookedTotalWeightUom', 'TotalBookedWeightUom', 'AlloySurcharge'];

  // MQF-445: GBR - The column Attachment was removed form the array (now is back) - Changed Name fro ColumnsToShow to ColumnsToShowRow (that indicate the grid inside the oData Grid)
  columnsToShowRow: string[] = ["customerItemNo", "feasibilityStatus", "costsStatus", "deliveryStatus", "unitSystem", "material.materialCode", "sms.description", "marketFamily.name", "marketingRoute", "customerDeliveryDate", "energySurcharge", "applicableNorms", "remark", "normGrades.normGradeCode", "gradeCustomerAnalysisLimitation.limitation",
    "gradeCustomerOtherLimitation.limitation", "rawMaterialGrade.rawMaterialGradeCode", "npsSchedule.npsDescription", "od", "odTolerancePlus", "odToleranceMinus", "odToleranceUom", "id", "idTolerancePlus", "idToleranceMinus", "idToleranceUom", "wt", "typeOfTolerance", "tubeExecution.description", "wtTolerancePlus", "wtToleranceMinus", "wtToleranceUom",
    "quantity", "quantityUom", "lengthType", "multipleLength", "lengthMin", "lengthMax", "lengthNominal", "lengthUom", "uBent", "totalWeight", "totalWeightUom", "mill.shortName", "surfaceType.name", "cts", "endsCondition", "testCondition", "sql.name", "offerScheme.offerSchemeDescription", "ut", "hydroTest", "ht", "htAdditional", 'dyePenetrant', 'dyePenetrant100P', 'penalty', 'colorCoding', 'specialOperations', 'specialTests', 'grindingHoning', 'ec', 'notStdPackaging', 'inspectionType3Dot2', 'multipleCutting',
    "icrIssued", "itrIssued", "idrIssued", "attachments", "fullCost", "extraCosts", "minimumFm", "recommendedFm", "customerBonus", "minimumPrice", "recommendedPrice", "actualFm", "actualFmAmountPerWeight", "negotiationMargin", "agentFee", "finalPrice", 'finalPricePerLength', 'totalPrice', 'alloySurchargeValue', 'energySurchargeValue', "initialPrice", "previousRevisionPrice", "extraLeadTime", "deliveryDate"];

  columnsToShowRowExpand: string[] = [...this.columnsToShowRow, 'isBooked'];
  closeEnquiryColumnsToShowRow: string[] = [...this.columnsToShowRow];
  cellSpecialStyles: CellSpecialStyle[] = [{ colName: 'DueDate', bgColorSourceData: 'DueDateColdor' }];
  customIcoCols: CustomIcoCol[] = new Array();
  calculatedCols: CalculatedCols[] = new Array();

  /*   enquiryBooks: EnquiryBook[] = new Array(); */
  oDataUrl: string = "";
  buttonsList: TTButton[] = new Array();

  dialogTitle: string = "";
  dialogIcon: string = "";
  showAddDialog: boolean = false;
  dialogButtons: DialogButton[] = new Array();
  enquiryForm: DialogForm[] = new Array();
  gridFilterable: boolean = false;
  clearFilters: boolean = false;
  showSettingsDialog: boolean = false;
  gridConfiguration: GridConfiguration = new GridConfiguration();
  headerParametersValues: HeaderParametersValues = new HeaderParametersValues();
  refreshGridKey: number = 0;
  elementPerRow: number = 5;
  showSelectCustomer: boolean = false;
  showCreateEditDummy: boolean = false;
  isCreateDummy: boolean = false;
  dummyCustomer: CreateEnquiryCustomer = new CreateEnquiryCustomer();
  showSelectNps: boolean = false;
  dataSetNps: any[] = new Array();
  columnsNps: string[] = ["npsScheduleId", "npsDescription", "nps", "schedule", "odMetric", "wtMetric", "odImperial", "wtImperial"];
  columnsToHideNps: string[] = ["npsScheduleId", "schedule", 'nps'];
  columnsToFilterNps: string[] = ["npsDescription"];
  dataSetCustomers: any[] = new Array();
  columnsCustomers: string[] = ['customerId', 'customerName', 'city', 'customerCode', 'unitSystem', 'isDummy'];
  columnsToHideCustomer: string[] = ["customerId", 'unitSystem', 'customerCountry']; //,'customerCode'
  columnsNorms: string[] = ['normCode', 'designation', 'edition', 'testCategory'];
  columnsToHideNorm: string[] = ["addenda", 'applicableNormId'];
  columnsNormGrades: string[] = ['normGradeCode'];
  columnsToHideNormGrades: string[] = ['normGradeId'];
  columnsMarketingGrades: string[] = ['marketingGradeCode', 'isDefault'];
  columnsToHideMarketingGrades: string[] = ['marketingGradeId'];
  columnsRawMaterialGrades: string[] = ['rawMaterialGradeCode'];
  columnsToHideRawMaterialGrades: string[] = ['rawMaterialGradeId', 'isDefault'];
  columnsSms: string[] = ['name', 'description'];
  columnsToHideSms: string[] = ['smsId'];
  showUploadFromAI: boolean = false;
  showSpecialRequirements: boolean = false;

  columnsWidth: ColumnWidth[] = new Array();
  enquiryToEdit: Enquiry = new Enquiry();
  showEditEnquiry: boolean = false;
  enquiryAllColumns: GridColumn[] = new Array();

  showExtraCosts: boolean = false;
  selectedExtraCostItem?: EnquiryHeaderItem;

  showItemDeliveryDates: boolean = false;
  selectedDeliveryDatesItem?: EnquiryHeaderItem;


  selectedNpsRow: NpsAndSchedule = new NpsAndSchedule();
  showDuplicateEnquiry: boolean = false;
  selectedEnquiryNo: string = "";
  showCloseEnquiry: boolean = false;
  selectedEnquiryStatus: string = "";
  refreshItem: boolean = false;
  dataSetItems: any[] = new Array();
  enquiryItems: ItemsByEnquiryNo = new ItemsByEnquiryNo();
  expandedEnquiryTotals: EnquiryTotalPriceAndMargin | null = null;
  expandedEnquiryTotalPriceFormatted: string = '';
  expandedEnquiryTotalMarginFormatted: string = '';
  expandedEnquiryTotalMarginClass: string = '';
  pendingExpandedTotalsEnquiryNo: string | null = null;
  columnsToHideItems: string[] = ['normGrades.normGradeId', 'marketingGrade.marketingGradeId', 'marketingGrade.marketingGradeCode', 'marketingGrade.isDefault', 'rawMaterialGrade.rawMaterialGradeId',
    'rawMaterialGrade.isDefault', 'npsSchedule.npsScheduleId', 'npsSchedule.nps', 'npsSchedule.schedule', 'npsSchedule.odMetric', 'npsSchedule.wtMetric', 'npsSchedule.odImperial',
    'npsSchedule.wtImperial', 'sms.smsId', 'sms.description', 'sms.marketingRoute', 'marketFamily.marketFamilyId', 'marketFamily.description', 'marketFamily.isDefaultForProject',
    'marketFamily.isDefaultForStock', 'surfaceType.surfaceTypeId', 'surfaceType.description', 'sql.sqlId', 'mill.millId', 'mill.name', 'mill.city', 'mill.country', 'marketingGrade',
    'tubeExecution.tubeExecutionId', 'tubeExecution.name', 'tubeExecution.isCustom', 'tubeExecution.toleranceMinusAw', 'tubeExecution.tolerancePlusAw',
    'tubeExecution.toleranceMinusMw', 'tubeExecution.tolerancePlusMw', 'tubeExecution.isDefaultForHot', 'tubeExecution.isDefaultForCold', 'optionDate'];

  itemParameterValues: ItemParametersValues = new ItemParametersValues();
  itemToDelete: string = "---";
  itemAttachments: ItemAttachment[] = new Array();
  showAttachments: boolean = false;
  isDuplicate: boolean = false;
  sourceEnquiryNo: string = "";
  expandedEnquiryNo: string | undefined | null = "";
  expandedEnquiryHeader?: EnquiryHeader;

  changeStatusEnquiryNo: string = "";
  showChangeStatus: boolean = false;
  enquiryMsOfferStatus: string = "";
  enquiryOfferStatus: string = "";
  exportToExcel: boolean = false;

  isDataFiltered: boolean = false;
  subscriptions: Subscription = new Subscription();

  roundDigits: RoundDigit[] = new Array();
  roundDigitsForGrid: RoundDigit[] = new Array();
  roundDigitsForEnquiryEditGrid: RoundDigit[] = new Array();
  roundDigitsForItemEditGrid: RoundDigit[] = new Array();
  roundDigitsForEnquiryForm: RoundDigit[] = new Array();
  roundDigitsForItemForm: RoundDigit[] = new Array();
  roundDigitsForEditInPlace: RoundDigit[] = new Array();

  dataSetNormGrades: NormGrade[] = new Array();

  showDocumentTemplateOptions: boolean = false;
  showDocumentTemplate: boolean = false;
  showDocumentTemplateEnquiryNo: string = "";
  showDocumentTemplateEnquiryStatus: string = "";
  enquiryAttachments: EnquiryAttachment[] = new Array();

  showSimilarEnquiriesModal = false;
  showOpenIDTCR = false;
  openIDTCR_EnquiryNo: string = "";
  openIDTCR_ItemNo: string = "";
  openIDTCR_Source: 'F' | 'P' | 'D' | undefined;
  showItdcrViewerModal: boolean = false;
  itdcrViewerNo: string = '';
  itdcrViewerShowHistory: boolean = false;


  filtersToHide: string[] = ["NumberOfAttachments", "AlloySurcharge"];
  enquiryBookFilterScope: string = "";
  enquiryInitialFilters: OdataGridInitialFilters[] = [];
  showFiltersOnLoad = false;

  similarEnquiriesEnquiryNo: string | null = null;
  pendingEnquiry: CreateEnquiry | null = null;
  private pendingAction: string | null = null;
  private pendingAttachments: AttachmentToUpdate[] | null = null;
  private pendingDuplicateEnquiry: CreateEnquiry | null = null;
  private pendingDuplicateAction: string | null = null;
  private pendingDuplicateAttachments: AttachmentToUpdate[] | null = null;
  private pendingReopenRevision: RevisionSavePayload | null = null;

  customerSpecialRequirements: CustomerSpecialRequirement[] = [];
  specialRequirementsReadOnly: boolean = false;

  showReopenModal: boolean = false;
  showPriceMarginChangesModal: boolean = false;
  priceMarginChangesEnquiryNo: string = "";
  priceMarginChangesMasterItems: EnquiryHeaderItem[] = [];
  priceMarginChangesAllowReverse: boolean = false;
  priceMarginChangesShowAIDialog: boolean = false;
  private pendingPriceMarginEnquiry: Enquiry | null = null;
  openEditPricesTrigger: number = 0;


  @ViewChild('viewCostHeader', { static: true }) viewCostHeader!: TemplateRef<any>;
  @ViewChild('viewCost', { static: true }) viewCostTemplate!: TemplateRef<any>;
  @ViewChild('viewExtraCosts', { static: true }) viewExtraCostsTemplate!: TemplateRef<any>;
  @ViewChild('viewDeliveryDates', { static: true }) viewDeliveryDates!: TemplateRef<any>;

  private readonly costHeaderUomByColumn: { [key: string]: string } = {
    initialPrice: 'costsUom',
    previousRevisionPrice: 'costsUom',
    finalPricePerLength: 'finalPricePerLengthUom',
    totalPrice: 'totalPriceUom',
    alloySurchargeValue: 'costsUom',
    energySurchargeValue: 'costsUom',
    fullCost: 'costsUom',
    minimumPrice: 'costsUom',
    recommendedPrice: 'costsUom',
    extraCosts: 'costsUom',
    finalPrice: 'costsUom',
    actualFmAmountPerWeight: 'costsUom'
  };

  customHeaderRenderers = {
    initialPrice: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'initialPrice' }
      };
    },
    previousRevisionPrice: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'previousRevisionPrice' }
      };
    },
    finalPricePerLength: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'finalPricePerLength' }
      };
    },
    totalPrice: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'totalPrice' }
      };
    },
    alloySurchargeValue: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'alloySurchargeValue' }
      };
    },
    energySurchargeValue: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'energySurchargeValue' }
      };
    },
    fullCost: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'fullCost' }
      };
    },
    minimumPrice: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'minimumPrice' }
      };
    },
    recommendedPrice: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'recommendedPrice' }
      };
    },
    extraCosts: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'extraCosts' }
      };
    },
    finalPrice: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'finalPrice' }
      };
    },
    actualFmAmountPerWeight: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'actualFmAmountPerWeight' }
      };
    }
  };

  customRenderers = {
    initialPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'initialPrice' }
      };
    },
    previousRevisionPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'previousRevisionPrice' }
      };
    },
    finalPricePerLength: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'finalPricePerLength', uomColumn: 'finalPricePerLengthUom' }
      };
    },
    totalPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'totalPrice', uomColumn: 'totalPriceUom' }
      };
    },
    deliveryDate: (row: any) => {
      return {
        template: this.viewDeliveryDates,
        context: { $implicit: row, column: 'delilveryDate' }
      };
    },
    alloySurchargeValue: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'alloySurchargeValue' }
      };
    },
    energySurchargeValue: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'energySurchargeValue' }
      };
    },
    fullCost: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'fullCost' }
      };
    },
    minimumPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'minimumPrice' }
      };
    },
    recommendedPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'recommendedPrice' }
      };
    },
    extraCosts: (row: any) => {
      return {
        template: this.viewExtraCostsTemplate,
        context: { $implicit: row }
      };
    },
    finalPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'finalPrice' }
      };
    },
    actualFmAmountPerWeight: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'actualFmAmountPerWeight' }
      };
    },
  };

  /* TENP TO REMOVE */
  @HostListener("window:keydown.Alt.m", ["$event"])
  onKeyDownAltM(e: any) {
    e.preventDefault();
    this.resetConfiguration();
  }

  constructor(public globals: Globals, private teiasoftLoader: TeiasoftLoaderService, private teiasoftToaster: TeiasoftToasterService,
    private backendService: BackendService, private translate: TranslateService, private teiasoftModalService: TeiasoftModalService,
    private utils: UtilsService, private activatedRoute: ActivatedRoute, private router: Router, private cdr: ChangeDetectorRef) {
    /* GET HEADERS PARAMETERS VALUES */
    this.getRoundDigits();
    this.checkUserConfiguration();
    this.setColumnsWidth();
    this.oDataUrl = "Enquiries";
  }

  ngOnInit(): void {

  }

  getCostColumnHeaderLabel(column: string): string {
    const baseLabel = this.getTranslatedColumnLabelWithoutUom(column);
    const uomColumn = this.costHeaderUomByColumn[column];
    const uomValue = this.getCostColumnUom(uomColumn);
    return uomValue ? `${baseLabel} (${uomValue})` : baseLabel;
  }

  private getCostColumnUom(uomColumn?: string): string {
    if (!uomColumn) {
      return '';
    }

    const fromGrid = this.dataSetItems.find(item => !!item?.[uomColumn])?.[uomColumn];
    if (fromGrid) {
      return fromGrid;
    }

    const fromItems = this.enquiryItems?.items?.find(item => !!(item as any)?.[uomColumn]) as any;
    return fromItems?.[uomColumn] ?? '';
  }

  private getTranslatedColumnLabelWithoutUom(column: string): string {
    const translationKey = 'grid.' + column.charAt(0).toUpperCase() + column.slice(1);
    const translatedLabel = this.translate.instant(translationKey);
    return this.stripHardcodedUomSuffix(translatedLabel);
  }

  private stripHardcodedUomSuffix(label: string): string {
    return (label || '').replace(/\s*\(?[^\s()]+\/[^\s()]+\)?\s*$/, '').trim();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  /* METHODS */
  getRoundDigits() {
    this.teiasoftLoader.start();
    this.subscriptions.add(this.utils.getRoundDigits().subscribe(res => {
      this.roundDigits = new Array();
      this.roundDigits = res; //.filter(x => x.section == 'Enquiries');
      this.roundDigitsForGrid = new Array();
      this.roundDigitsForGrid = res.filter(x => x.section == 'Enquiries' && x.api == 'GetEnquiries');
      this.roundDigitsForEnquiryEditGrid = new Array();
      this.roundDigitsForEnquiryEditGrid = res.filter(x => x.section == 'EditEnquiry' && x.api == 'EditAndCreateVersionIfNecessary');
      this.roundDigitsForItemEditGrid = new Array();
      this.roundDigitsForItemEditGrid = res.filter(x => x.section == 'EditEnquiryItem' && x.api == 'EditAndCreateVersionIfNecessary');
      this.roundDigitsForEnquiryForm = new Array();
      this.roundDigitsForEnquiryForm = res.filter(x => x.section == 'EnquiryForm' && x.api == 'CreateEnquiry/EditEnquiry');
      this.roundDigitsForItemForm = new Array();
      this.roundDigitsForItemForm = res.filter(x => x.section == 'ItemForm' && x.api == 'UpdateEnquiryItems');
      this.roundDigitsForEditInPlace = new Array();
      this.roundDigitsForEditInPlace = res.filter(x => x.section == 'EditInPlace' && x.api == 'UpdateEnquiryItems');
      this.getHeaderParametersValues();
    }));
  }

  getHeaderParametersValues(): Promise<void> {
    this.teiasoftLoader.start();
    return new Promise((resolve, reject) => {
      this.subscriptions.add(this.backendService.getHeaderParametersValues().subscribe(res => {
        this.headerParametersValues = new HeaderParametersValues();
        if (res) {
          res.countries?.sort((a, b) => {
            if (a.countryName! < b.countryName!) {
              return -1;
            }
            if (a.countryName! > b.countryName!) {
              return 1;
            }
            return 0;
          });
          this.headerParametersValues = res;
          this.getItemParametersValues();
        }
        resolve();
      },
        err => {
          reject(err);
        }
      ));
    }
    );
  }

  getItemParametersValues() {
    this.subscriptions.add(this.backendService.getItemParametersValues().subscribe(res => {
      this.itemParameterValues = new ItemParametersValues();
      this.itemParameterValues = res;
      this.teiasoftLoader.stop();
      /* CHECK CONFIGURATION FOR GRID */
      //this.checkUserConfiguration();

      // Devo prendere anche le nps per la duplicate
      this.getNpsAndSchedules(false); // MQF-381
      this.getNormGrades('');

      this.manageBackFromCostingTool();
    }));
  }

  checkUserConfiguration() {
    this.gridConfiguration = new GridConfiguration();
    const userConfiguration = this.utils.getUserConfiguration();
    const savedConfiguration = userConfiguration.gridsConfigurations?.find(cfg => cfg.name === 'EnquiryBook');

    if (savedConfiguration) {
      this.gridConfiguration = savedConfiguration;
    } else {
      this.gridConfiguration.name = 'EnquiryBook';
      this.gridConfiguration.gridColumns = new Array();
      this.gridConfiguration.defaultFilterView = 'GetAll';
    }

    this.updateEnquiryBookFilterScope();

    /* BUILD BUTTONS FOR TOOLBAR */
    this.buildButtonsList();
    this.buildCustomIconGrid();
    this.buildCalculatedCols();
  }

  private updateEnquiryBookFilterScope(): void {
    switch (this.gridConfiguration.defaultFilterView) {
      case 'GetMy':
        this.enquiryBookFilterScope = 'My';
        break;
      case 'GetOffice':
        this.enquiryBookFilterScope = 'Office';
        break;
      default:
        this.enquiryBookFilterScope = '';
        break;
    }
  }

  setColumnsWidth() {
    this.columnsWidth = new Array();
    let _col: ColumnWidth = new ColumnWidth();
    _col.colName = "CustomerName";
    _col.length = 100;
    _col.width = 100;
    this.columnsWidth.push(_col);

    _col = new ColumnWidth();
    _col.colName = "ApplicableNorms";
    _col.length = 100;
    _col.width = 100;
    this.columnsWidth.push(_col);

    _col = new ColumnWidth();
    _col.colName = "Remark";
    _col.length = 100;
    _col.width = 100;
    this.columnsWidth.push(_col);
  }

  manageBackFromCostingTool() {
    this.subscriptions.add(this.activatedRoute.queryParams.subscribe(params => {
      const enquiryNo = params["enquiryNo"];
      if (!enquiryNo) {
        return;
      }

      const expandFlag = this.parseIsExpandFlag(params["isExpand"]);
      if (expandFlag !== false) {
        this.setEnquiryNoFilter(enquiryNo);
      }

      if (expandFlag === false) {
        this.editAndCreateVersionIfNecessary(enquiryNo);
        this.router.navigate([], { queryParams: {} });
      } else if (expandFlag === true) {
        this.expandedEnquiryNo = enquiryNo;
      }
    }));
  }

  private setEnquiryNoFilter(enquiryNo: string) {
    this.enquiryInitialFilters = [{
      column: 'EnquiryNo',
      type: 'string',
      value: enquiryNo
    }];
    this.showFiltersOnLoad = this.enquiryInitialFilters.length > 0;
    this.gridFilterable = this.showFiltersOnLoad;
    this.buildButtonsList();
  }

  private parseIsExpandFlag(rawValue: any): boolean | null {
    if (rawValue === undefined || rawValue === null) {
      return null;
    }

    const normalized = rawValue.toString().toLowerCase();
    if (normalized === 'false' || normalized === '0') {
      return false;
    }

    return true;
  }

  /* REGION BUILD */
  //#region Build
  buildButtonsList() {
    this.buttonsList = new Array();
    /* ALL */
    let _item: TTButton = new TTButton();
    _item.disabled = false;
    _item.icon = '';
    _item.id = 0;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "allEnquiries";
    _item.action = "filter|GetAll";
    _item.type = "toggle";
    _item.toggleText = 'all';
    _item.state = (this.gridConfiguration.defaultFilterView == 'GetAll' || this.gridConfiguration.defaultFilterView == '' || !this.gridConfiguration.defaultFilterView) ? 'pressed' : '';
    this.buttonsList.push(_item);

    /* MINE */
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = '';
    _item.id = 1;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "myEnquiries";
    _item.action = "filter|GetMy";
    _item.type = "toggle";
    _item.toggleText = 'my';
    _item.state = this.gridConfiguration.defaultFilterView == 'GetMy' ? 'pressed' : '';
    this.buttonsList.push(_item);

    /* OFFICE */
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = '';
    _item.id = 2;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "officeEnquiries";
    _item.action = "filter|GetOffice";
    _item.type = "toggle";
    _item.toggleText = 'office';
    _item.state = this.gridConfiguration.defaultFilterView == 'GetOffice' ? 'pressed' : '';
    this.buttonsList.push(_item);

    /* SEPARATOR */
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = '';
    _item.id = 3;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "";
    _item.action = "";
    _item.type = "separator";
    _item.state = '';
    this.buttonsList.push(_item);


    /* ADD ENQUIRY */
    _item = new TTButton();
    _item.disabled = this.utils.isAuthorized('Office', "CreateEnquiry", null) ? false : true;
    _item.icon = 'fal fa-plus';
    _item.id = 5;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "addEnquiry";
    _item.action = "add";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);

    /* EDIT GRID */
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = 'fal fa-wrench';
    _item.id = 6;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "editGrid";
    _item.action = "showSettingsGrid";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);

    /* SHOW/HIDE FILTER */
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = !this.gridFilterable ? 'fal fa-filter' : 'fal fa-filter-circle-xmark';
    _item.id = 7;
    _item.size = "";
    _item.text = "";
    _item.tooltip = !this.gridFilterable ? "showGridFilters" : "hideGridFilters";
    _item.action = !this.gridFilterable ? "showFilter" : "closeFilter";
    _item.type = '';
    _item.state = this.isDataFiltered ? 'pressed' : '';
    this.buttonsList.push(_item);

    /* CLEAR FILTERS */
    _item = new TTButton();
    _item.disabled = !this.gridFilterable ? true : false;
    _item.icon = 'fal fa-eraser';
    _item.id = 8;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "clearGridFilters";
    _item.action = "clearFilter";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);

    /* EXCEL */
    _item = new TTButton();
    _item.disabled = this.utils.isAuthorized('Global', "ExportEnquiries", null) ? false : true;;
    _item.icon = 'fal fa-file-download';
    _item.id = 4;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "exportEnquiry";
    _item.action = "export";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);
  }

  buildCustomIconGrid() {
    this.customIcoCols = new Array();

    /* OPEN ACTION ON ENQUIRY MENU*/
    let _item: CustomIcoCol = new CustomIcoCol();
    _item.action = '';
    _item.icon = new Array();
    _item.icon = ['fal fa-ellipsis-h'];
    _item.tooltip = "grid.openEnqActions"; //this.translate.instant("grid.openEnqActions");
    _item.position = "start";
    _item.disabled = false;
    _item.isMenu = true;
    _item.menuVoices = new Array();
    let _voice: MenuVoice = new MenuVoice();
    _voice.text = "enquiryBook.duplicateEnquiry"; // this.translate.instant("enquiryBook.duplicateEnquiry");
    _voice.action = "duplicateEnquiry";
    _item.menuVoices.push(_voice);
    _voice = new MenuVoice();
    _voice.text = "enquiryBook.closeEnquiry"; //this.translate.instant("enquiryBook.closeEnquiry");
    _voice.action = "closeEnquiry";
    _item.menuVoices.push(_voice);
    _voice = new MenuVoice();
    _voice.text = "enquiryBook.changeStatus"; //this.translate.instant("enquiryBook.changeStatus");
    _voice.action = "changeStatus";
    _item.menuVoices.push(_voice);

    _voice = new MenuVoice();
    _voice.text = "enquiryBook.showDocumentTemplate";
    _voice.action = "showDocumentTemplate";
    _item.menuVoices.push(_voice);

    _voice = new MenuVoice();
    _voice.text = "enquiryBook.reopenEnquiry";
    _voice.action = "reopenEnquiry";
    _item.menuVoices.push(_voice);


    _voice = new MenuVoice();
    _voice.text = "enquiryBook.openITDCR";
    _voice.action = "openITDCR";
    _item.menuVoices.push(_voice);

    this.customIcoCols.push(_item);

    /*     _item = new CustomIcoCol();
        _item.action = 'duplicateEnquiry';
        _item.icon = new Array();
        _item.icon = ['fal fa-clone'];
        _item.tooltip = this.translate.instant("enquiryBook.duplicateEnquiry");
        _item.position = "start";
        _item.disabled = false;
        _item.isMenu = false;
        this.customIcoCols.push(_item); */

    /* OPEN EDIT MENU */
    _item = new CustomIcoCol();
    _item.action = "editEnquiry";
    _item.icon = new Array();
    _item.icon = ['fal fa-pencil-alt'];
    _item.tooltip = this.translate.instant("grid.openEditEnqMenu");
    _item.position = "start";
    _item.disabled = false;
    _item.isMenu = false;
    this.customIcoCols.push(_item);

    /* EXPAND ROW */
    _item = new CustomIcoCol();
    _item.action = "expandRow|Items"; // Flag that expand the single row | obcjet to expand
    _item.icon = new Array();
    _item.icon = ['fal fa-plus', 'fal fa-minus'];
    _item.tooltip = this.translate.instant("grid.openItems");
    _item.position = "start";
    _item.disabled = false;
    _item.isMenu = false;
    this.customIcoCols.push(_item);


    /* QUOTATION DOWNLOAD */
    _item = new CustomIcoCol();
    _item.action = "downloadQuotation";
    _item.getIcon = (row: any) => {
      if (row.QuotationExists)
        return row.IsQuotationFinal ? ['fa-light fa-file-circle-check'] : ['fa-light fa-file-lines'];
      return ['']
    };
    _item.getTooltip = (row: any) => row.IsQuotationFinal ? this.translate.instant("quotation.download") : this.translate.instant("quotation.downloadDraft");
    _item.position = "start";
    _item.disabled = false;
    _item.isMenu = false;
    this.customIcoCols.push(_item);

  }

  buildCalculatedCols() {
    this.calculatedCols = new Array();
    /* FEASIBILITY CALCULATED COL */
    let _item: CalculatedCols = new CalculatedCols();
    _item.id = 0;
    _item.icon = '';
    _item.method = 'calculateItemsValidity|FeasibilityStatus';
    _item.tooltip = '';
    _item.position = 'start';
    _item.header = "F";
    this.calculatedCols.push(_item);

    /* PRICE CALCULATED COL */
    _item = new CalculatedCols();
    _item.id = 1;
    _item.icon = '';
    _item.method = 'calculateItemsValidity|CostsStatus';
    _item.tooltip = '';
    _item.position = 'start';
    _item.header = "P";
    this.calculatedCols.push(_item);

    /* DELIVERY CALCULATED COL */
    _item = new CalculatedCols();
    _item.id = 2;
    _item.icon = '';
    _item.method = 'calculateItemsValidity|DeliveryStatus';
    _item.tooltip = '';
    _item.position = 'start';
    _item.header = "D";
    this.calculatedCols.push(_item);


  }

  buildAddEnquiryForm(action: 'add' | 'edit') {
    this.enquiryForm = new Array();
    let _item: DialogForm = new DialogForm();
    let _i: number = 0;

    //#region Row1
    _item.id = _i
    _item.labelText = this.translate.instant("grid.CustomerId");
    _item.placeHolder = this.translate.instant("grid.CustomerId");
    _item.field = "customerId";
    _item.type = 'text';
    _item.disabled = true;
    _item.isRequired = false;
    _item.value = null;
    _item.text = null;
    _item.fullWidth = false;
    _item.visible = false;
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.CustomerName");
    _item.placeHolder = this.translate.instant("grid.CustomerName");
    _item.field = "customerName";
    _item.type = 'text';
    _item.disabled = false;
    _item.isRequired = true;
    _item.value = '';
    _item.text = '';
    _item.optionsList = new Array();
    _item.fullWidth = false;
    _item.visible = true;
    _item.colSpan = 2;
    _item.autoCompleteField = "customer";
    _item.autoComplete = true;
    _item.autoCompleteDataset = new Array();
    _item.autoCompleteDataset = this.getFirst100Data('customers', 'customerName'); //this.headerParametersValues.customers!;

    // Se sono in edit e il customer non è presente nei 100 la aggiungo
    if (this.enquiryToEdit && this.enquiryToEdit.header && this.enquiryToEdit.header.customer!) {
      if (_item.autoCompleteDataset!.findIndex(x => x.customerId == this.enquiryToEdit.header!.customer?.customerId) == -1)
        _item.autoCompleteDataset!.unshift(this.enquiryToEdit.header.customer);
    }

    _item.autoCompleteColumns = new Array();
    _item.autoCompleteColumns = this.columnsCustomers;
    _item.autoCompleteColumnsToHide = new Array();
    _item.autoCompleteColumnsToHide = this.columnsToHideCustomer;
    _item.columnsWidthPerc = new Array();
    _item.columnsWidthPerc = [55, 15, 10, 10, 10];
    _item.showCreate = true;
    _item.selectable = false;
    _item.multiSelection = false;
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.CustomerCountry");
    _item.placeHolder = this.translate.instant("grid.CustomerCountry");
    _item.field = "customerCountry";
    _item.type = 'text';
    _item.disabled = false;
    _item.isRequired = false;
    _item.value = '';
    _item.text = '';
    _item.fullWidth = false;
    _item.visible = true;
    _item.readOnly = true;
    _item.refClassWidth = "dialog-row-20-element";
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.CustomerCode");
    _item.placeHolder = this.translate.instant("grid.CustomerCode");
    _item.field = "customerCode";
    _item.type = 'text';
    _item.disabled = false;
    _item.isRequired = false;
    _item.value = null;
    _item.text = null;
    _item.fullWidth = false;
    _item.visible = true;
    _item.readOnly = true;
    _item.refClassWidth = "dialog-row-20-element";
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.MstOfferStatus");
    _item.placeHolder = this.translate.instant("grid.MstOfferStatus");
    _item.field = "mstOfferStatus";
    _item.type = 'select';
    _item.disabled = false;
    _item.isRequired = true;
    _item.value = '';
    _item.text = '';
    _item.fullWidth = false;
    _item.visible = true;
    _item.readOnly = false;
    _item.optionsList = new Array();
    _item.optionsList = this.getMstOfferStatus();
    _item.refClassWidth = "dialog-row-20-element";
    this.enquiryForm.push(_item);

    //#endregion

    //#region Row2


    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.CustomerCountryId");
    _item.placeHolder = this.translate.instant("grid.CustomerCountryId");
    _item.field = "customerCountryId";
    _item.type = 'text';
    _item.disabled = true;
    _item.isRequired = false;
    _item.value = null;
    _item.text = null;
    _item.fullWidth = false;
    _item.visible = false;
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.OfferScheme");
    _item.placeHolder = this.translate.instant("grid.OfferScheme");
    _item.field = "offerSchemeCode";
    _item.type = 'select';
    _item.disabled = false;
    _item.isRequired = true;
    _item.text = '';
    _item.fullWidth = false;
    _item.visible = true;
    _item.optionsList = this.getOfferSchemes();
    _item.value = _item.optionsList.find(opt => opt.isDefault)?.value ?? '';
    _item.text = _item.optionsList.find(opt => opt.isDefault)?.text ?? '';
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.BonusScheme");
    _item.placeHolder = this.translate.instant("grid.BonusScheme");
    _item.field = "bonusSchemeCode";
    _item.type = 'select';
    _item.disabled = false;
    _item.isRequired = true;
    _item.text = '';
    _item.fullWidth = false;
    _item.visible = true;
    _item.optionsList = this.getBonusSchemes();
    _item.value = _item.optionsList.find(opt => opt.isDefault)?.value ?? '';
    _item.text = _item.optionsList.find(opt => opt.isDefault)?.text ?? '';
    this.enquiryForm.push(_item);


    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("enquiryBook.UnitSystem");
    _item.placeHolder = this.translate.instant("enquiryBook.UnitSystem");
    _item.field = "unitSystem";
    _item.type = 'select';
    _item.disabled = this.isDuplicate;
    _item.isRequired = true;
    _item.value = '';
    _item.text = '';
    _item.fullWidth = false;
    _item.visible = true;
    _item.optionsList = new Array();
    _item.optionsList = this.getUnitSystems();
    _item.refClassWidth = "dialog-row-20-element";
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.Currency");
    _item.placeHolder = this.translate.instant("grid.Currency");
    _item.field = "currency";
    _item.type = 'select';
    _item.disabled = this.isDuplicate;
    _item.isRequired = true;
    _item.value = '';
    _item.text = '';
    _item.fullWidth = false;
    _item.visible = true;
    _item.optionsList = this.getCurrencies();
    _item.refClassWidth = "dialog-row-20-element";
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.SalesPerson");
    _item.placeHolder = this.translate.instant("grid.SalesPerson");
    _item.field = "salesPerson";
    _item.type = 'select';
    _item.disabled = false;
    _item.isRequired = true;
    _item.optionsList = new Array();
    _item.optionsList = this.getSalesPersons();
    _item.value = this.headerParametersValues.salesPersons!.findIndex(x => x.isDefault == true) == -1 ? '' : this.headerParametersValues.salesPersons!.filter(x => x.isDefault == true)[0].userId!;
    _item.text = this.headerParametersValues.salesPersons!.findIndex(x => x.isDefault == true) == -1 ? '' : this.headerParametersValues.salesPersons!.filter(x => x.isDefault == true)[0].username!;
    let _salesPersonId: number = _item.value;
    _item.fullWidth = false;
    _item.visible = true;
    _item.refClassWidth = "dialog-row-20-element";
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.SalesOffice");
    _item.placeHolder = this.translate.instant("grid.SalesOffice");
    _item.field = "salesOfficeId";
    _item.type = 'select';
    _item.disabled = false;
    _item.isRequired = true;
    _item.optionsList = new Array();
    _item.optionsList = this.getSalesOffices();
    // Get Sales Office default value based on SalesPerson
    let _salesOfficePerson: SalesOfficePerson[] = new Array();
    _salesOfficePerson = this.headerParametersValues.salesPersons!.filter(x => x.userId == _salesPersonId)[0].salesOffices!;
    if (_salesOfficePerson && _salesOfficePerson.length > 0) {
      _item.value = _salesOfficePerson.filter(o => o.isDefault! == true)[0] ? _salesOfficePerson.filter(o => o.isDefault! == true)[0].officeId : _salesOfficePerson[0].officeId!;
      _item.text = this.headerParametersValues.salesOffices!.filter(x => x.officeId == _item.value)[0].officeCode!;
    } else {
      _item.value = '';
      _item.text = '';
    }

    /*  _item.value = this.headerParametersValues.salesOffices!.findIndex(x => x.isDefault == true) == -1 ? '' : this.headerParametersValues.salesOffices!.filter(x => x.isDefault == true)[0].officeId!;
     _item.text =  this.headerParametersValues.salesOffices!.findIndex(x => x.isDefault == true) == -1 ? '' : this.headerParametersValues.salesOffices!.filter(x => x.isDefault == true)[0].officeCode!; */
    _item.fullWidth = false;
    _item.visible = true;
    _item.refClassWidth = "dialog-row-20-element";
    this.enquiryForm.push(_item);

    /*     _item = new DialogForm();
        _item.id = _i++;
        _item.labelText = ""
        _item.placeHolder = ""
        _item.field = "";
        _item.type = 'emptyField';
        _item.disabled = false;
        _item.isRequired = false;
        _item.value = '';
        _item.text = '';
        _item.fullWidth = false;
        _item.visible = true;
        _item.refClassWidth = "dialog-row-20-element";
        this.enquiryForm.push(_item); */
    //#endregion

    //#region Row3


    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.CustomerEnquiryNo");
    _item.placeHolder = this.translate.instant("grid.CustomerEnquiryNo");
    _item.field = "customerEnquiryNo";
    _item.type = 'text';
    _item.disabled = false;
    _item.isRequired = false;
    _item.value = null;
    _item.text = null;
    _item.fullWidth = false;
    _item.visible = true;
    _item.readOnly = false;
    _item.refClassWidth = "dialog-row-20-element";
    _item.maxLength = 50;
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.MarketingRoute");
    _item.placeHolder = this.translate.instant("grid.MarketingRoute");
    _item.field = "smsMarketingRoute";
    _item.type = 'select';
    _item.disabled = false;
    _item.isRequired = true;
    _item.fullWidth = false;
    _item.visible = true;
    _item.optionsList = new Array();
    _item.optionsList = this.getSmsMarketingRoute();
    _item.value = _item.optionsList[0].value!;
    _item.text = _item.optionsList[0].text!;
    _item.refClassWidth = "dialog-row-20-element";

    this.enquiryForm.push(_item);


    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.Sms");
    _item.placeHolder = this.translate.instant("grid.Sms");
    _item.field = "sms";
    _item.type = 'select';
    _item.disabled = false;
    _item.isRequired = true;
    _item.value = '';
    _item.text = '';
    _item.fullWidth = false;
    _item.visible = true;
    _item.optionsList = new Array();
    _item.optionsList = this.getSms();
    _item.refClassWidth = "dialog-row-20-element";
    /*     _item.autoCompleteField = 'sms';
        _item.autoComplete = false;
        _item.autoCompleteDataset = new Array();
        _item.autoCompleteDataset =  this.headerParametersValues.sms!
        _item.autoCompleteColumns = new Array();
        _item.autoCompleteColumns = this.columnsSms;
        _item.autoCompleteColumnsToHide = new Array();
        _item.autoCompleteColumnsToHide = this.columnsToHideSms;
        _item.columnsWidthPerc = new Array();
        _item.columnsWidthPerc = [40,40,10,10];
        _item.selectable = false;
        _item.multiSelection = false; */
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.AlloySurcharge");
    _item.placeHolder = this.translate.instant("grid.AlloySurcharge");
    _item.field = "alloySurcharge";
    _item.type = 'select';
    _item.disabled = false;
    _item.isRequired = false;
    _item.value = '';
    _item.text = '';
    _item.optionsList = new Array();
    _item.optionsList = this.getAlloySurcharge();
    _item.fullWidth = false;
    _item.visible = false; // MQF 1073: PRICING 
    _item.refClassWidth = "dialog-row-20-element";
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.projectName");
    _item.placeHolder = this.translate.instant("grid.projectName");
    _item.field = "projectName";
    _item.type = 'text';
    _item.disabled = false;
    _item.isRequired = false;
    _item.value = null;
    _item.text = null;
    _item.fullWidth = false;
    _item.visible = true;
    _item.refClassWidth = "dialog-row-20-element";
    _item.maxLength = 50;
    this.enquiryForm.push(_item);


    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.orderReason");
    _item.placeHolder = this.translate.instant("grid.orderReason");
    _item.field = "orderReason";
    _item.type = 'select';
    _item.disabled = this.isDuplicate;
    _item.isRequired = true;
    _item.optionsList = new Array();
    _item.optionsList = this.getOrderReasons();
    _item.value = _item.optionsList[0].value!;
    _item.text = _item.optionsList[0].text!;
    _item.fullWidth = false;
    _item.visible = true;
    _item.refClassWidth = "dialog-row-20-element";
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.testCategory");
    _item.placeHolder = this.translate.instant("grid.testCategory");
    _item.field = 'testCategory';
    _item.type = 'select';
    _item.disabled = true;
    _item.isRequired = false;
    _item.value = '';
    _item.text = '';
    _item.fullWidth = false;
    _item.visible = false;
    _item.optionsList = new Array();
    _item.optionsList = this.getTestCategories();
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.MarketFamily");
    _item.placeHolder = this.translate.instant("grid.MarketFamily");
    _item.field = "marketFamily";
    _item.type = 'select';
    _item.disabled = false;
    _item.isRequired = true;
    _item.value = '';
    _item.text = '';
    _item.fullWidth = false;
    _item.visible = true;
    _item.optionsList = new Array();
    _item.optionsList = this.getMarketFamily();
    _item.refClassWidth = "dialog-row-20-element";
    this.enquiryForm.push(_item);

    /*     _item = new DialogForm();
        _item.id = _i++;
        _item.labelText = ""
        _item.placeHolder = ""
        _item.field = "";
        _item.type = 'emptyField';
        _item.disabled = false;
        _item.isRequired = false;
        _item.value = '';
        _item.text = '';
        _item.fullWidth = false;
        _item.visible = true;
        _item.refClassWidth = "dialog-row-20-element";
        this.enquiryForm.push(_item); */
    //#endregion

    //#region Row4
    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.ApplicableNorms");
    _item.placeHolder = this.translate.instant("grid.ApplicableNorms");
    _item.field = "applicableNorms";
    _item.type = 'text';
    _item.disabled = false;
    _item.isRequired = false;
    _item.value = null;
    _item.text = null;
    _item.fullWidth = false;
    _item.visible = true;
    _item.refClassWidth = "dialog-row-20-element";
    /* _item.autoCompleteField = 'applicableNorms';
    _item.autoComplete = true;
    _item.autoCompleteDataset = new Array();
    _item.autoCompleteDataset = this.headerParametersValues.applicableNorms!;
    _item.autoCompleteColumns = new Array();
    _item.autoCompleteColumns = this.columnsNorms;
    _item.autoCompleteColumnsToHide = new Array();
    _item.autoCompleteColumnsToHide = this.columnsToHideNorm;
    _item.columnsWidthPerc = new Array();
    _item.columnsWidthPerc = [40,40,10,10];
    _item.selectable = true;
    _item.multiSelection = true; */
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.NormGrades");
    _item.placeHolder = this.translate.instant("grid.NormGrades");
    _item.field = "normGrades";
    _item.type = 'text';
    _item.disabled = false;
    _item.isRequired = true;
    _item.value = '';
    _item.text = '';
    _item.fullWidth = false;
    _item.visible = true;
    _item.autoCompleteField = 'normGrades';
    _item.autoComplete = true;
    _item.autoCompleteColumns = new Array();
    _item.autoCompleteColumns = this.columnsNormGrades;
    _item.autoCompleteColumnsToHide = new Array();
    _item.autoCompleteColumnsToHide = this.columnsToHideNormGrades;
    _item.columnsWidthPerc = new Array();
    _item.columnsWidthPerc = [100];
    _item.selectable = true;
    _item.multiSelection = true;
    _item.fullWidth = false;
    _item.colSpan = 3;
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.RawMaterialGrade");
    _item.placeHolder = this.translate.instant("grid.RawMaterialGrade");
    _item.field = "rawMaterialGrades";
    _item.type = 'text';
    _item.disabled = true;
    _item.isRequired = false;
    _item.value = '';
    _item.text = '';
    _item.optionsList = new Array();
    _item.optionsList = [];
    _item.fullWidth = false;
    _item.visible = true;
    _item.autoCompleteField = 'rawMaterialGrades';
    _item.autoComplete = true;
    _item.autoCompleteColumns = new Array();
    _item.autoCompleteColumns = this.columnsRawMaterialGrades;
    _item.autoCompleteColumnsToHide = new Array();
    _item.autoCompleteColumnsToHide = this.columnsToHideRawMaterialGrades;
    _item.columnsWidthPerc = new Array();
    _item.columnsWidthPerc = [80, 20];
    _item.anchor = 'left';
    _item.selectable = false;
    _item.multiSelection = false;
    _item.refClassWidth = "dialog-row-20-element";
    this.enquiryForm.push(_item);

    //#region Row5
    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = "";
    _item.placeHolder = "";
    _item.field = "toolbarWtOdIdNps";
    _item.type = 'toolbar';
    _item.disabled = false;
    _item.isRequired = false;
    _item.value = "";
    _item.text = '';
    _item.fullWidth = false;
    _item.visible = true;
    _item.toolbarButtonsList = new Array();
    _item.toolbarButtonsList = this.getWtOdIDNpsTTButtons();
    _item.refClassWidth = "dialog-row-20-element";
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.OutsideDiameter");
    _item.placeHolder = this.translate.instant("grid.OutsideDiameter");
    _item.field = "od";
    _item.type = 'number';
    _item.disabled = false;
    _item.isRequired = true;
    _item.value = null;
    _item.text = null;
    _item.fullWidth = false;
    _item.visible = true;
    _item.refClassWidth = "dialog-row-20-element";
    _item.roundDigits = 2;
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.OdUom");
    _item.placeHolder = this.translate.instant("grid.OdUom");
    _item.field = "odUom";
    _item.type = 'select';
    _item.disabled = false;
    _item.isRequired = true;
    _item.value = null;
    _item.text = null;
    _item.optionsList = new Array();
    _item.optionsList = this.getUoms('odUoms');
    _item.fullWidth = false;
    _item.visible = false;
    _item.refClassWidth = "dialog-row-20-element";
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.InsideDiameter");
    _item.placeHolder = this.translate.instant("grid.InsideDiameter");
    _item.field = "id";
    _item.type = 'number';
    _item.disabled = false;
    _item.isRequired = true;
    _item.value = null;
    _item.text = null;
    _item.fullWidth = false;
    _item.visible = true;
    _item.refClassWidth = "dialog-row-20-element";
    _item.roundDigits = 2;
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.IdUom");
    _item.placeHolder = this.translate.instant("grid.IdUom");
    _item.field = "idUom";
    _item.type = 'select';
    _item.disabled = false;
    _item.isRequired = true;
    _item.value = null;
    _item.text = null;
    _item.optionsList = new Array();
    _item.optionsList = this.getUoms('idUoms');
    _item.fullWidth = false;
    _item.visible = false;
    _item.refClassWidth = "dialog-row-20-element";
    this.enquiryForm.push(_item);
    //#endregion

    //#region Row6
    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.WallThickness");
    _item.placeHolder = this.translate.instant("grid.WallThickness");
    _item.field = "wt";
    _item.type = 'number';
    _item.disabled = false;
    _item.isRequired = true;
    _item.value = null;
    _item.text = null;
    _item.fullWidth = false;
    _item.visible = true;
    _item.refClassWidth = "dialog-row-20-element";
    _item.roundDigits = 2;
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.WtUom");
    _item.placeHolder = this.translate.instant("grid.WtUom");
    _item.field = "wtUom";
    _item.type = 'select';
    _item.disabled = false;
    _item.isRequired = false;
    _item.value = null;
    _item.text = null;
    _item.optionsList = new Array();
    _item.optionsList = this.getUoms('wtUoms');
    _item.fullWidth = false;
    _item.visible = false;
    _item.refClassWidth = "dialog-row-20-element";
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++
    _item.labelText = this.translate.instant("grid.NpsDescription");
    _item.placeHolder = this.translate.instant("grid.NpsDescription");
    _item.field = "npsDescription";
    _item.type = 'text';
    _item.disabled = true;
    _item.isRequired = false;
    _item.value = null;
    _item.text = null;
    _item.fullWidth = false;
    _item.visible = true;
    _item.readOnly = true;
    _item.refClassWidth = "dialog-row-20-element";
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++
    _item.labelText = this.translate.instant("grid.TotalWeight");
    _item.placeHolder = this.translate.instant("grid.TotalWeight");
    _item.field = "totalWeight";
    _item.type = 'number';
    _item.disabled = false;
    _item.isRequired = true;
    _item.value = null;
    _item.text = null;
    _item.fullWidth = false;
    _item.visible = true;
    _item.refClassWidth = "dialog-row-20-element";
    _item.roundDigits = 2;
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.TotalWeightUom");
    _item.placeHolder = this.translate.instant("grid.TotalWeightUom");
    _item.field = "totalWeightUom";
    _item.type = 'select';
    _item.disabled = false;
    _item.isRequired = true;
    _item.value = '';
    _item.text = '';
    _item.optionsList = new Array();
    _item.optionsList = this.getUoms('totalWeightUoms');
    _item.fullWidth = false;
    _item.visible = true;
    _item.refClassWidth = "dialog-row-20-element";
    this.enquiryForm.push(_item);
    //#endregion

    //#region Row7
    _item = new DialogForm();
    _item.id = _i++
    _item.labelText = this.translate.instant("grid.Length");
    _item.placeHolder = this.translate.instant("grid.Length");
    _item.field = "length";
    _item.type = 'number';
    _item.disabled = false;
    _item.isRequired = false;
    _item.value = null;
    _item.text = null;
    _item.fullWidth = false;
    _item.visible = false;
    _item.refClassWidth = "dialog-row-20-element";
    _item.roundDigits = 2;
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.LengthUom");
    _item.placeHolder = this.translate.instant("grid.LengthUom");
    _item.field = "lengthUom";
    _item.type = 'select';
    _item.disabled = false;
    _item.isRequired = false;
    _item.value = '';
    _item.text = '';
    _item.optionsList = new Array();
    _item.optionsList = this.getUoms('lengthUoms');
    _item.fullWidth = false;
    _item.visible = false;
    _item.refClassWidth = "dialog-row-20-element";
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.Remark");
    _item.placeHolder = this.translate.instant("grid.Remark");
    _item.field = "remark";
    _item.type = 'text';
    _item.disabled = false;
    _item.isRequired = false;
    _item.value = null;
    _item.text = null;
    _item.fullWidth = false;
    _item.visible = true;
    _item.colSpan = 3;

    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.OfferValidity");
    _item.placeHolder = this.translate.instant("grid.OfferValidity");
    _item.field = "offerValidityId";
    _item.type = 'select';
    _item.disabled = false;
    _item.isRequired = true;
    _item.text = null;
    _item.fullWidth = false;
    _item.visible = true;
    _item.optionsList = new Array();
    _item.optionsList = this.getOfferValidityOptions();
    _item.value = _item.optionsList?.find(opt => opt.isDefault)?.value;
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.OfferValidityDate");
    _item.placeHolder = this.translate.instant("grid.OfferValidityDate");
    _item.field = "offerValidityDate";
    _item.type = 'date';
    _item.disabled = false;
    _item.isRequired = false;
    _item.value = null;
    _item.text = null;
    _item.fullWidth = false;
    _item.visible = false;
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.CustomerRequestDate");
    _item.placeHolder = this.translate.instant("grid.CustomerRequestDate");
    _item.field = "customerRequestDate";
    _item.type = 'date';
    _item.disabled = action == 'add' ? false : true;
    _item.isRequired = action == 'add' ? true : false;
    _item.readOnly = action == 'add' ? false : true;
    _item.value = null;
    _item.text = null;
    _item.fullWidth = false;
    _item.visible = true;
    _item.maxDate = new Date();
    this.enquiryForm.push(_item);

    _item = new DialogForm();
    _item.id = _i++;
    _item.labelText = this.translate.instant("grid.DueDate");
    _item.placeHolder = this.translate.instant("grid.DueDate");
    _item.field = "dueDate";
    _item.type = 'date';
    _item.disabled = false;
    _item.isRequired = false;
    _item.value = null;
    _item.text = null;
    _item.fullWidth = false;
    _item.visible = true;
    _item.refClassWidth = "dialog-row-20-element";
    this.enquiryForm.push(_item);

    //#endregion

    //if (action == 'add'){
    return this.getNormGrades('');
    //}
  }

  buildDialogButtons() {
    this.dialogButtons = new Array();
    let _btn: DialogButton = new DialogButton();
    _btn.id = 0;
    _btn.action = 'addAttachment';
    _btn.buttonType = "tb-primary";
    _btn.text = this.translate.instant("commons.attachFile");
    _btn.disabled = false;
    this.dialogButtons.push(_btn);

    _btn = new DialogButton();
    _btn.id = 2;
    _btn.action = 'specialRequirements';
    _btn.buttonType = "tb-primary";
    _btn.text = this.translate.instant("enquiryBook.specialRequirements");
    _btn.disabled = false;
    this.dialogButtons.push(_btn);

    _btn = new DialogButton();
    _btn.id = 3;
    _btn.action = 'save';
    _btn.buttonType = "tb-secondary";
    _btn.text = this.translate.instant("commons.save");
    _btn.disabled = false;
    this.dialogButtons.push(_btn);

    _btn = new DialogButton();
    _btn.id = 4;
    _btn.action = 'save-add-items';
    _btn.secondaryAction = 'save-add-items-AI';
    _btn.secondaryActionIcon = 'fa-solid fa-sparkles';
    _btn.buttonType = "tb-secondary";
    _btn.text = this.translate.instant("commons.saveAndAddItem");
    _btn.disabled = false;
    this.dialogButtons.push(_btn);

    _btn = new DialogButton();
    _btn.id = 5;
    _btn.action = 'cancel';
    _btn.buttonType = "tb-cancel";
    _btn.text = this.translate.instant("commons.cancel");
    _btn.disabled = false;
    this.dialogButtons.push(_btn);

    this.updateSpecialRequirementsButtonText();
  }

  private updateSpecialRequirementsButtonText(): void {
    const btn = this.dialogButtons.find(b => b.action === 'specialRequirements');
    if (!btn) {
      return;
    }
    const count = this.customerSpecialRequirements?.length ?? 0;
    btn.text = this.translate.instant("enquiryBook.specialRequirements");
    if (count > 0) {
      btn.text += ` (${count})`;
    }
  }

  getFirst100Data(obj: string, propertyName: string): any[] {
    if (!this.headerParametersValues) return [];
    if (!(this.headerParametersValues as any)[obj]) return [];
    return (this.headerParametersValues as any)[obj]!
      .slice() // Create a shallow copy of the array to avoid modifying the original array
      .sort((a: any, b: any) => {
        let nameA: string = a[propertyName]!.toUpperCase(); // ignore upper and lowercase
        let nameB: string = b[propertyName]!.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        // names must be equal
        return 0;
      }) // Sort by the 'score' property in descending order
      .slice(0, 100); // Take the top 100 records

  }
  //#endregion

  updateUserConfiguration() {

    this.subscriptions.add(this.backendService.updateUserConfiguration(this.globals.userLogged!.configuration!, this.globals.userLogged!.language!, this.globals.userLogged!.dateFormat!).subscribe(res => {

      // MQF-263: sync also localstorage 
      localStorage.setItem("userLogged", JSON.stringify(this.globals.userLogged!));

      // HI - 7/12/2023 - Rif. MQF-03 - Commentato
      //this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
      // END MQF-03
    }));
  }

  checkForSimilarEnquiriesAndCreateEnquiry(enquiry: CreateEnquiry, action: string, attachments: AttachmentToUpdate[]) {
    if (!enquiry.projectName || enquiry.projectName.trim().length < 4) {
      // No projectName, proceed with creation
      this.createEnquiry(enquiry, action, attachments);
      return;
    }

    // Store the pending data before showing the modal
    this.pendingEnquiry = enquiry;
    this.pendingAction = action;
    this.pendingAttachments = attachments;

    this.showSimilarEnquiriesModal = true;
  }


  createEnquiry(enquiry: CreateEnquiry, action: string, attachments: AttachmentToUpdate[]) {

    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.createEnquiry(enquiry).subscribe(res => {
      if (attachments && attachments.length > 0) {
        this.uploadEnquiryAttachment(enquiry, action, res["enquiryNo"], attachments);
      } else {
        this.completeEnquiryCreation(enquiry, action, res["enquiryNo"]);
      }

    }));
  }

  uploadEnquiryAttachment(enquiry: CreateEnquiry, action: string, enquiryNo: string, attachments: AttachmentToUpdate[]) {
    this.backendService.uploadEnquiryAttachment(enquiryNo, attachments).subscribe(res => {
      this.completeEnquiryCreation(enquiry, action, enquiryNo);
    });
  }

  private completeEnquiryCreation(enquiry: CreateEnquiry, action: string, enquiryNo: string) {
    const openEditAfterCreate = action == 'save-add-items' || action == 'save-add-items-AI';

    this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
    this.showAddDialog = false;
    this.dummyCustomer = new CreateEnquiryCustomer();
    if (enquiry.customerId == null) this.getHeaderParametersValues(); // Ricarico gli header paramenter values se ho dummy customer

    if (openEditAfterCreate) {
      this.editAndCreateVersionIfNecessary(enquiryNo, action == 'save-add-items-AI').then(() => {
        this.refreshFullGrid();
      }).catch(() => {
        this.refreshFullGrid();
      });
      return;
    }

    this.teiasoftLoader.stop();
    this.refreshFullGrid();
  }

  getEnquiryByEnquiryNo(enquiryNo: string) {
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.getEnquiryByEnquiryNo(enquiryNo).subscribe(res => {
      this.sourceEnquiryNo = enquiryNo;

      const continueDuplicateFlow = () => {
        this.buildDialogButtons();
        this.teiasoftLoader.stop();
        this.buildAddEnquiryForm('add').then(() => { this.fillFormForDuplicate(res) }); // finally proceed wil form filling
      };

      if (res.enquiry?.hasCustomerSpecialRequirements) {
        this.subscriptions.add(this.backendService.getEnquiryCustomerSpecialRequirements(enquiryNo).subscribe({
          next: (csrRes) => {
            this.customerSpecialRequirements = csrRes.customerSpecialRequirements || new Array();
          },
          error: () => {
            this.customerSpecialRequirements = new Array();
          },
          complete: () => {
            continueDuplicateFlow();
          }
        }));
        return;
      }

      this.customerSpecialRequirements = new Array();
      continueDuplicateFlow();
    }));
  }

  fillFormForDuplicate(enquiry: EnquiryByEnquiryNo) {
    let _i: number = 0;

    // CHECK IF CUSTOMER STILL IS IN LIST
    let _iC: number = this.headerParametersValues.customers!.findIndex(x => x.customerId == enquiry.enquiry!.customer!.customerId!);

    _i = this.enquiryForm.findIndex(x => x.field == 'customerId');
    this.enquiryForm[_i].value = _iC != -1 ? enquiry.enquiry!.customer!.customerId! : null;
    this.enquiryForm[_i].text = _iC != -1 ? enquiry.enquiry!.customer!.customerId!.toString() : null;

    _i = this.enquiryForm.findIndex(x => x.field == 'customerName');
    this.enquiryForm[_i].value = _iC != -1 ? enquiry.enquiry!.customer!.customerName : null;
    this.enquiryForm[_i].text = _iC != -1 ? enquiry.enquiry!.customer!.customerName! : null;
    // Se il customer è ancora attivo verifico che sia nei 100 del dataset, se non c'è lo aggiungo
    if (_iC != -1) {
      if (this.enquiryForm[_i].autoCompleteDataset!.findIndex(x => x.customerId == enquiry.enquiry!.customer?.customerId) == -1)
        this.enquiryForm[_i].autoCompleteDataset!.unshift(enquiry.enquiry!.customer);
    }

    _i = this.enquiryForm.findIndex(x => x.field == 'customerEnquiryNo');
    this.enquiryForm[_i].value = enquiry.enquiry!.customerEnquiryNo!;
    this.enquiryForm[_i].text = enquiry.enquiry!.customerEnquiryNo!;

    _i = this.enquiryForm.findIndex(x => x.field == 'mstOfferStatus');
    this.enquiryForm[_i].value = this.headerParametersValues.mstOfferStatus?.find(os => os == enquiry.enquiry!.mstOfferStatus);
    this.enquiryForm[_i].text = this.headerParametersValues.mstOfferStatus?.find(os => os == enquiry.enquiry!.mstOfferStatus);

    _i = this.enquiryForm.findIndex(x => x.field == 'customerCountry');
    this.enquiryForm[_i].value = _iC != -1 ? enquiry.enquiry!.customer!.customerCountry!.countryId : null;
    this.enquiryForm[_i].text = _iC != -1 ? enquiry.enquiry!.customer!.customerCountry!.countryName : null;

    _i = this.enquiryForm.findIndex(x => x.field == 'customerCode');
    this.enquiryForm[_i].value = _iC != -1 ? enquiry.enquiry!.customer!.customerCode : null;
    this.enquiryForm[_i].text = _iC != -1 ? enquiry.enquiry!.customer!.customerCode! : null;

    _i = this.enquiryForm.findIndex(x => x.field == 'unitSystem');
    this.enquiryForm[_i].value = enquiry.enquiry!.unitSystem;
    this.enquiryForm[_i].text = this.translate.instant("enquiryBook." + enquiry.enquiry!.unitSystem);
    this.setSelectUoms();

    this.setCurrencyFormValue(enquiry.enquiry!.currency ?? this.getDefaultCurrencyForCountry(enquiry.enquiry!.customer?.customerCountry?.countryId));

    _i = this.enquiryForm.findIndex(x => x.field == 'dueDate');
    this.enquiryForm[_i].value = enquiry.enquiry!.dueDate ? enquiry.enquiry!.dueDate : ''; // this.datePipe.transform( enquiry.enquiry!.dueDate!, this.dtFormat)!; 
    this.enquiryForm[_i].text = enquiry.enquiry!.dueDate! ? enquiry.enquiry!.dueDate!.toString() : ''; //this.datePipe.transform( enquiry.enquiry!.dueDate!, this.dtFormat)!; //

    // _i = this.enquiryForm.findIndex(x => x.field == 'optionDate');
    // this.enquiryForm[_i].value = enquiry.enquiry!.optionDate ? enquiry.enquiry!.optionDate : '';
    // this.enquiryForm[_i].text = enquiry.enquiry!.optionDate! ? enquiry.enquiry!.optionDate!.toString() : '';

    /*     _i = this.enquiryForm.findIndex(x => x.field == 'salesPerson');
        this.enquiryForm[_i].value =  this.headerParametersValues.salesPersons!.filter(x => x.username == enquiry.enquiry!.salesPerson)[0].userId;
        this.enquiryForm[_i].text = enquiry.enquiry!.salesPerson;
    
        _i = this.enquiryForm.findIndex(x => x.field == 'salesOfficeId');
        this.enquiryForm[_i].value = this.headerParametersValues.salesOffices!.filter(x => x.officeCode ==  enquiry.enquiry!.salesOffice)[0].officeId!;
        this.enquiryForm[_i].text =  enquiry.enquiry!.salesOffice;  */

    // MQF-337 - By Default has to be me (user logged)
    _i = this.enquiryForm.findIndex(x => x.field == 'salesPerson');
    this.enquiryForm[_i].value = this.headerParametersValues.salesPersons!.filter(x => x.username == this.globals.userLogged!.username!)[0].userId!;
    this.enquiryForm[_i].text = this.headerParametersValues.salesPersons!.filter(x => x.username == this.globals.userLogged!.username!)[0].username!;

    _i = this.enquiryForm.findIndex(x => x.field == 'salesOfficeId');
    let _salesOfficePerson: SalesOfficePerson[] = new Array();
    _salesOfficePerson = this.headerParametersValues.salesPersons!.filter(x => x.username == this.globals.userLogged!.username!)[0].salesOffices!;
    let _iSO: number = _salesOfficePerson.findIndex(x => x.isDefault == true);
    if (_iSO != -1) {
      this.enquiryForm[_i].value = _salesOfficePerson[_iSO].officeId!;
      this.enquiryForm[_i].text = this.headerParametersValues.salesOffices!.filter(x => x.officeId == _salesOfficePerson[_iSO].officeId)[0].officeCode;
    } else {
      this.enquiryForm[_i].value = _salesOfficePerson[0].officeId!;
      this.enquiryForm[_i].text = this.headerParametersValues.salesOffices!.filter(x => x.officeId == _salesOfficePerson[0].officeId)[0].officeCode;
    }
    // END MQF-337

    _i = this.enquiryForm.findIndex(x => x.field == 'projectName');
    this.enquiryForm[_i].value = enquiry.enquiry!.projectName;
    this.enquiryForm[_i].text = enquiry.enquiry!.projectName!;

    // MQF-370 - Obslete value - GBR 12/07/2024
    /* _i = this.enquiryForm.findIndex(x => x.field == 'sms');
    let _k: number = this.headerParametersValues.sms!.findIndex(x => x.smsId ==  enquiry.enquiry!.sms!.smsId);
    this.enquiryForm[_i].value = this.headerParametersValues.sms![_k].smsId;
    this.enquiryForm[_i].text = this.headerParametersValues.sms![_k].description!; */

    _i = this.enquiryForm.findIndex(x => x.field == 'smsMarketingRoute');
    let _k: number = this.headerParametersValues.sms!.findIndex(x => x.smsId == enquiry.enquiry!.sms!.smsId);
    if (_k != -1) {
      this.enquiryForm[_i].value = this.headerParametersValues.sms![_k].marketingRoute;
      this.enquiryForm[_i].text = this.headerParametersValues.sms![_k].marketingRoute!;
    }

    _i = this.enquiryForm.findIndex(x => x.field == 'sms');
    _k = this.headerParametersValues.sms!.findIndex(x => x.smsId == enquiry.enquiry!.sms!.smsId);
    if (_k != -1) {
      this.enquiryForm[_i].value = this.headerParametersValues.sms![_k].smsId;
      this.enquiryForm[_i].text = this.headerParametersValues.sms![_k].description!;
    } else {
      this.enquiryForm[_i].value = null;
      this.enquiryForm[_i].text = null;
      //this.enquiryForm[_i].isValid = this.enquiryForm[_i].isRequired  ? false : true;
    }
    // END MQF-370

    _i = this.enquiryForm.findIndex(x => x.field == 'alloySurcharge');
    this.enquiryForm[_i].value = enquiry.enquiry!.alloySurcharge;
    this.enquiryForm[_i].text = this.translate.instant("grid." + enquiry.enquiry!.alloySurcharge);

    _i = this.enquiryForm.findIndex(x => x.field == 'orderReason');
    this.enquiryForm[_i].value = enquiry.enquiry!.orderReason;
    this.enquiryForm[_i].text = this.translate.instant("grid." + enquiry.enquiry!.orderReason);

    _i = this.enquiryForm.findIndex(x => x.field == 'marketFamily');
    this.enquiryForm[_i].value = enquiry.enquiry!.marketFamily?.marketFamilyId;
    this.enquiryForm[_i].text = enquiry.enquiry!.marketFamily?.name!; // MQF-381

    _i = this.enquiryForm.findIndex(x => x.field == 'applicableNorms');
    this.enquiryForm[_i].value = enquiry.enquiry!.applicableNorms!;
    this.enquiryForm[_i].text = enquiry.enquiry!.applicableNorms!;

    /*  _i = this.enquiryForm.findIndex(x => x.field == 'normGrades');
     if ( enquiry.enquiry!.normGrades) {
       this.enquiryForm[_i].value =  enquiry.enquiry!.normGrades!.map(x => x.normGradeId).join(',');
       this.enquiryForm[_i].text =  enquiry.enquiry!.normGrades!.map(x => x.normGradeCode).join(',');
     } else {
       this.enquiryForm[_i].value = "";
       this.enquiryForm[_i].text = "";
     } */
    _i = this.enquiryForm.findIndex(x => x.field == 'normGrades');
    let _newList: EnquiyNormGrade[] = new Array();
    let _clearRawMaterial: boolean = false;
    for (var t = 0; t < enquiry.enquiry!.normGrades!.length; t++) {
      let _ngI: number = this.dataSetNormGrades.findIndex(x => x["normGradeId"] == enquiry.enquiry!.normGrades![t].normGradeId);
      if (_ngI == -1) {
        // Pulisco il dataset dell'oggetto che non esiste più
        this.enquiryForm[_i].autoCompleteDataset = this.dataSetNormGrades!.filter(x => x["normGradeId"] != enquiry.enquiry!.normGrades![t].normGradeId!);
        _clearRawMaterial = true;
      } else {
        _newList.push(enquiry.enquiry!.normGrades![t]);
      }
    }
    enquiry.enquiry!.normGrades = _newList;
    _newList = new Array();

    if (enquiry.enquiry!.normGrades) {
      this.enquiryForm[_i].value = enquiry.enquiry!.normGrades!.map(x => x.normGradeId).join(',');
      this.enquiryForm[_i].text = enquiry.enquiry!.normGrades!.map(x => x.normGradeCode).join(',');
    } else {
      this.enquiryForm[_i].value = "";
      this.enquiryForm[_i].text = "";
    }
    /*** */

    // MQF-335
    if (this.enquiryForm[_i].value != "") {
      let _ids: number[] = new Array();
      for (var x = 0; x < this.enquiryForm![_i].value!.toString().split(',').length; x++) {
        _ids.push(parseInt(this.enquiryForm![_i].value!.toString().split(',')[x]));
      }
      this.getRawMaterialGrades('', _ids);
    }
    //END MQF-335

    _i = this.enquiryForm.findIndex(x => x.field == 'rawMaterialGrades');
    this.enquiryForm[_i].value = enquiry.enquiry!.rawMaterialGrade; // ? enquiry.enquiry!.rawMaterialGrade!.rawMaterialGradeId : null;
    this.enquiryForm[_i].text = enquiry.enquiry!.rawMaterialGrade; // ? enquiry.enquiry!.rawMaterialGrade!.rawMaterialGradeCode : null;
    this.enquiryForm[_i].disabled = false;
    this.enquiryForm[_i].readOnly = false;

    let _npsSchedule: boolean = (enquiry.enquiry!.npsSchedule && enquiry.enquiry!.npsSchedule.npsScheduleId) ? true : false;
    if (_npsSchedule) {
      _i = this.enquiryForm.findIndex(x => x.field == 'toolbarWtOdIdNps');
      this.enquiryForm[_i].toolbarButtonsList![0].state = '';
      this.enquiryForm[_i].toolbarButtonsList![1].state = 'pressed';
    }

    _i = this.enquiryForm.findIndex(x => x.field == 'od');
    this.enquiryForm[_i].value = enquiry.enquiry!.od ? enquiry.enquiry!.od : '';
    this.enquiryForm[_i].text = enquiry.enquiry!.od ? enquiry.enquiry!.od!.toString() : '';
    if (_npsSchedule) this.enquiryForm[_i].readOnly = true;
    if (_npsSchedule) this.enquiryForm[_i].isRequired = false;


    _i = this.enquiryForm.findIndex(x => x.field == 'odUom');
    this.enquiryForm[_i].value = enquiry.enquiry!.odUom ? enquiry.enquiry!.odUom : '';
    this.enquiryForm[_i].text = enquiry.enquiry!.odUom ? enquiry.enquiry!.odUom : '';
    if (_npsSchedule) this.enquiryForm[_i].readOnly = true;
    if (_npsSchedule) this.enquiryForm[_i].isRequired = false;

    _i = this.enquiryForm.findIndex(x => x.field == 'id');
    this.enquiryForm[_i].value = enquiry.enquiry!.id;
    this.enquiryForm[_i].text = enquiry.enquiry!.id ? enquiry.enquiry!.id!.toString() : '';
    if (_npsSchedule) this.enquiryForm[_i].disabled = true;
    if (_npsSchedule) this.enquiryForm[_i].isRequired = false;

    _i = this.enquiryForm.findIndex(x => x.field == 'idUom');
    this.enquiryForm[_i].value = enquiry.enquiry!.idUom ? enquiry.enquiry!.idUom : '';
    this.enquiryForm[_i].text = enquiry.enquiry!.idUom ? enquiry.enquiry!.idUom : '';
    if (_npsSchedule) this.enquiryForm[_i].disabled = true;
    if (_npsSchedule) this.enquiryForm[_i].isRequired = false;

    _i = this.enquiryForm.findIndex(x => x.field == 'wt');
    this.enquiryForm[_i].value = enquiry.enquiry!.wt ? enquiry.enquiry!.wt : '';
    this.enquiryForm[_i].text = enquiry.enquiry!.wt ? enquiry.enquiry!.wt! : '';
    if (_npsSchedule) this.enquiryForm[_i].readOnly = true;
    if (_npsSchedule) this.enquiryForm[_i].isRequired = false;

    _i = this.enquiryForm.findIndex(x => x.field == 'wtUom');
    this.enquiryForm[_i].value = enquiry.enquiry!.wtUom ? enquiry.enquiry!.wtUom : '';
    this.enquiryForm[_i].text = enquiry.enquiry!.wtUom ? enquiry.enquiry!.wtUom : '';
    if (_npsSchedule) this.enquiryForm[_i].readOnly = true;
    if (_npsSchedule) this.enquiryForm[_i].isRequired = false;

    // MQF-370 - Obsolete values - GBR 12/07/2024
    /* _i = this.enquiryForm.findIndex(x => x.field == 'npsDescription');
    if ( enquiry.enquiry!.npsSchedule) {
      this.enquiryForm[_i].value =  enquiry.enquiry!.npsSchedule.npsScheduleId!;
      this.enquiryForm[_i].text =  enquiry.enquiry!.npsSchedule.nps;
    } else {
      this.enquiryForm[_i].value = '';
      this.enquiryForm[_i].text = '';
    } */

    _i = this.enquiryForm.findIndex(x => x.field == 'npsDescription');
    if (enquiry.enquiry!.npsSchedule) {
      this.enquiryForm[_i].isRequired = true;
      // GBR 16/02/2024
      // MQF-98 - Se l'oggetto non è nella lista resetto valori
      _k = this.dataSetNps.findIndex(x => x["npsScheduleId"] == enquiry.enquiry!.npsSchedule!.npsScheduleId!); // MQF-381
      if (_k != -1) {
        this.enquiryForm[_i].value = enquiry.enquiry!.npsSchedule.npsScheduleId!;
        this.enquiryForm[_i].text = enquiry.enquiry!.npsSchedule.npsDescription; // MQF-383
      } else {
        this.enquiryForm[_i].value = '';
        this.enquiryForm[_i].text = '';
        this.enquiryForm[_i].isValid = false;
        // DEVO ANCHE PULIRE OD/WT e relative Uoms
        _i = this.enquiryForm.findIndex(x => x.field == 'od');
        this.enquiryForm[_i].value = null;
        this.enquiryForm[_i].text = null;
        _i = this.enquiryForm.findIndex(x => x.field == 'odUom');
        this.enquiryForm[_i].value = null;
        this.enquiryForm[_i].text = null;
        _i = this.enquiryForm.findIndex(x => x.field == 'wt');
        this.enquiryForm[_i].value = null;
        this.enquiryForm[_i].text = null;
        _i = this.enquiryForm.findIndex(x => x.field == 'wtUom');
        this.enquiryForm[_i].value = null;
        this.enquiryForm[_i].text = null;
      }

    } else {
      this.enquiryForm[_i].value = '';
      this.enquiryForm[_i].text = '';
      //this.enquiryForm[_i].isRequired = false;
    }
    // END MQF-370

    _i = this.enquiryForm.findIndex(x => x.field == 'totalWeight');
    this.enquiryForm[_i].value = enquiry.enquiry!.totalWeight != null ? enquiry.enquiry!.totalWeight : '';
    this.enquiryForm[_i].text = enquiry.enquiry!.totalWeight != null ? enquiry.enquiry!.totalWeight?.toString() : '';
    if (!enquiry.enquiry!.isTotalWeightEditable) this.enquiryForm[_i].disabled = true;

    _i = this.enquiryForm.findIndex(x => x.field == 'totalWeightUom');
    this.enquiryForm[_i].value = enquiry.enquiry!.totalWeightUom ? enquiry.enquiry!.totalWeightUom : '';
    this.enquiryForm[_i].text = enquiry.enquiry!.totalWeightUom ? enquiry.enquiry!.totalWeightUom : '';

    _i = this.enquiryForm.findIndex(x => x.field == 'length');
    this.enquiryForm[_i].value = enquiry.enquiry!.length ? enquiry.enquiry!.length : '';
    this.enquiryForm[_i].text = enquiry.enquiry!.length ? enquiry.enquiry!.length!.toString() : '';

    _i = this.enquiryForm.findIndex(x => x.field == 'lengthUom');
    this.enquiryForm[_i].value = enquiry.enquiry!.lengthUom ? enquiry.enquiry!.lengthUom : '';
    this.enquiryForm[_i].text = enquiry.enquiry!.lengthUom ? enquiry.enquiry!.lengthUom : '';

    _i = this.enquiryForm.findIndex(x => x.field == 'remark');
    this.enquiryForm[_i].value = enquiry.enquiry!.remark!;
    this.enquiryForm[_i].text = enquiry.enquiry!.remark!;

    _i = this.enquiryForm.findIndex(x => x.field == 'offerValidityId');
    this.enquiryForm[_i].value = enquiry.enquiry!.offerValidity?.id!;
    this.enquiryForm[_i].text = enquiry.enquiry!.offerValidity?.id;

    _i = this.enquiryForm.findIndex(x => x.field == 'offerSchemeCode');
    if (_i != -1) {
      const offerSchemeCode = enquiry.enquiry!.offerScheme?.offerSchemeCode ?? this.enquiryForm[_i].value ?? '';
      const offerSchemeOption = this.enquiryForm[_i].optionsList?.find(opt => opt.value == offerSchemeCode);
      this.enquiryForm[_i].value = offerSchemeCode;
      this.enquiryForm[_i].text = offerSchemeOption?.text ?? offerSchemeCode;
    }

    _i = this.enquiryForm.findIndex(x => x.field == 'bonusSchemeCode');
    if (_i != -1) {
      const bonusSchemeCode = enquiry.enquiry!.bonusScheme?.bonusSchemeCode ?? this.enquiryForm[_i].value ?? '';
      const bonusSchemeOption = this.enquiryForm[_i].optionsList?.find(opt => opt.value == bonusSchemeCode);
      this.enquiryForm[_i].value = bonusSchemeCode;
      this.enquiryForm[_i].text = bonusSchemeOption?.text ?? bonusSchemeCode;
    }

    this.setRoundDigitsEnquiryForm();
    this.dialogTitle = this.translate.instant("enquiryBook.duplicateEnquiry");
    this.dialogIcon = "fal fa-copy";
    this.showAddDialog = true;
  }

  /* GET VARIOUS LIST METHODS */
  getUnitSystems(): SelectOption[] {
    return [
      { value: 'Metric', text: this.translate.instant("enquiryBook.metric") },
      { value: 'Imperial', text: this.translate.instant("enquiryBook.imperial") }
    ];
  }

  getCurrencies(): SelectOption[] {
    return (this.headerParametersValues.currencies ?? []).map(currency => {
      const option = new SelectOption();
      option.value = currency;
      option.text = currency;
      return option;
    });
  }

  private getDefaultCurrencyForCountry(countryId?: number | null): string {
    if (countryId == null) return '';
    return this.headerParametersValues.countries?.find(country => country.countryId == countryId)?.defaultCurrency ?? '';
  }

  private setCurrencyFormValue(currency?: string | null) {
    const index = this.enquiryForm.findIndex(x => x.field == 'currency');
    if (index == -1) return;

    const value = currency ?? '';
    this.enquiryForm[index].value = value;
    this.enquiryForm[index].text = value;
  }

  getAddEnquiryTTButtons(): TTButton[] {
    let _list: TTButton[] = new Array();

    /* SELECT CUSTOMER */
    let _item: TTButton = new TTButton();
    _item.disabled = false;
    _item.icon = 'fal fa-search';
    _item.id = 0;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "selectCustomer";
    _item.action = "select|customer";
    _item.type = "";
    _item.state = "";
    _list.push(_item);

    /* CREATE DUMMY */
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = 'fal fa-plus';
    _item.id = 1;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "createDummy";
    _item.action = "create|dummy";
    _item.type = "";
    _item.state = "";
    _list.push(_item);

    /* EDIT DUMMY */
    _item = new TTButton();
    _item.disabled = true;
    _item.icon = 'fal fa-pen';
    _item.id = 2;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "editDummy";
    _item.action = "edit|dummy";
    _item.type = "";
    _item.state = "";
    _list.push(_item);

    /* DELETE DUMMY */
    _item = new TTButton();
    _item.disabled = true;
    _item.icon = 'fal fa-eraser';
    _item.id = 3;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "deleteDummy";
    _item.action = "delete|dummy";
    _item.type = "";
    _item.state = "";
    _list.push(_item);

    return _list;
  }

  getWtOdIDNpsTTButtons(): TTButton[] {
    let _list: TTButton[] = new Array();

    let _item: TTButton = new TTButton();
    _item.disabled = false;
    _item.icon = '';
    _item.id = 5;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "wtOdId";
    _item.action = "select|wtOdIt";
    _item.type = "toggle";
    _item.state = "pressed";
    _item.toggleText = "wtOdId";
    _list.push(_item);

    _item = new TTButton();
    _item.disabled = false;
    _item.icon = '';
    _item.id = 6;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "nps";
    _item.action = "select|nps";
    _item.type = "toggle";
    _item.state = '';
    _item.toggleText = "nps";
    _list.push(_item);

    return _list;
  }

  getTestCategories(): SelectOption[] {
    let _list: SelectOption[] = new Array();
    if (!this.headerParametersValues.testCategories) return _list;
    for (var x = 0; x < this.headerParametersValues.testCategories!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.headerParametersValues.testCategories![x];
      _item.value = this.headerParametersValues.testCategories![x];
      _list.push(_item);
    }
    return _list;
  }

  getMarketFamily(): SelectOption[] {
    let _list: SelectOption[] = new Array();
    if (!this.headerParametersValues.marketFamily) return _list;
    for (var x = 0; x < this.headerParametersValues.marketFamily!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = this.headerParametersValues.marketFamily![x].name;
      _item.value = this.headerParametersValues.marketFamily![x].marketFamilyId;
      _list.push(_item);
    }
    return _list;
  }

  /*   getCustomerList(): SelectOption[] {
      let _list: SelectOption[] = new Array();
      let _item: SelectOption = new SelectOption();
      _item.text = "Teiasoft Srls";
      _item.value = "T";
      _list.push(_item);
      return _list;
    } */

  getOrderReasons(): SelectOption[] {
    const _list: SelectOption[] = [];
    let defaultOption: SelectOption | null = null;

    for (const reason of this.headerParametersValues.orderReasons!) {
      const _item: SelectOption = new SelectOption();
      _item.value = reason.value;
      _item.text = reason.value;

      if (reason.isDefault) {
        defaultOption = _item; // Capture the default option
      } else {
        _list.push(_item); // Add non-default options to the list
      }
    }
    return defaultOption ? [defaultOption, ..._list] : _list;
  }


  getSalesPersons(): SelectOption[] {
    let _list: SelectOption[] = new Array();
    for (var x = 0; x < this.headerParametersValues.salesPersons!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.value = this.headerParametersValues.salesPersons![x].userId;
      _item.text = this.headerParametersValues.salesPersons![x].username;
      _list.push(_item);
    }
    return _list;
  }

  getSalesOffices(): SelectOption[] {
    // Al primo giro carico i sales office associati al sales person di default
    let _offices: SalesOfficePerson[] = new Array();
    _offices = this.headerParametersValues.salesPersons!.filter(x => x.isDefault == true)[0].salesOffices!;
    let _list: SelectOption[] = new Array();
    for (var x = 0; x < _offices!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.value = _offices[x].officeId;
      _item.text = this.headerParametersValues.salesOffices!.filter(o => o.officeId == _offices[x].officeId)[0].officeCode!;
      _list.push(_item);
    }

    return _list;
  }

  getMstOfferStatus(): SelectOption[] {
    let _list: SelectOption[] = new Array();
    for (var x = 0; x < this.headerParametersValues.mstOfferStatus!.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.value = this.headerParametersValues.mstOfferStatus![x];
      _item.text = this.headerParametersValues.mstOfferStatus![x];
      _list.push(_item);
    }
    return _list;
  }

  /*   getApplicableNorms(): SelectOption[] {
      let _list: SelectOption[] = new Array();
      for (var x = 0; x < this.headerParametersValues.applicableNorms!.length; x++){
        let _item: SelectOption = new SelectOption();
        _item.text = this.headerParametersValues.applicableNorms![x];
        _item.value = this.headerParametersValues.applicableNorms![x];
        _list.push(_item);
      }
      return _list;
    } */

  getMarketingGrades(): SelectOption[] {
    let _list: SelectOption[] = new Array();
    let _normGrades: string[] = new Array();
    let _i: number = this.enquiryForm.findIndex(x => x.field == 'normGrades');
    if (this.enquiryForm[_i].value != '') {
      if (this.enquiryForm[_i].value.toString().indexOf(',') != -1)
        _normGrades = this.enquiryForm[_i].value.split(",");
      else
        _normGrades.push(this.enquiryForm[_i].value!);
    }

    //if (_normGrades && _normGrades.length > 0){
    this.subscriptions.add(this.backendService.getMarketingGrades(_normGrades).subscribe(res => {
      if (res && res.marketingGrades) {
        /* for (var x=0; x < res.marketingGrades.length; x++){
           let _item: SelectOption = new SelectOption();
          _item.text = res.marketingGrades[x].marketingGrade!;
          _item.value = res.marketingGrades[x].marketingGrade!;
          _list.push(_item);
        } */

        _i = this.enquiryForm.findIndex(x => x.field == 'marketingGrades');
        this.enquiryForm[_i].autoCompleteDataset = new Array();
        this.enquiryForm[_i].autoCompleteDataset = res.marketingGrades;

      }
      return _list
    }));
    return _list;
  }

  getRawMaterialGrades_old(value: string, normGradeIds: number[]) {
    this.subscriptions.add(this.backendService.getRawMaterialGrades(normGradeIds).subscribe(res => {
      if (res && res.rawMaterialGrades) {
        let _i: number = this.enquiryForm.findIndex(x => x.field == 'rawMaterialGrades');
        this.enquiryForm[_i].autoCompleteDataset = new Array();
        if (res.rawMaterialGrades.length > 0) {
          this.enquiryForm[_i].disabled = false;
          if (value != '') {
            this.enquiryForm[_i].autoCompleteDataset = res.rawMaterialGrades.filter(x => x.rawMaterialGradeCode!.toLowerCase().includes(value.toLowerCase()));
          } else {
            this.enquiryForm[_i].autoCompleteDataset = res.rawMaterialGrades!
              .slice() // Create a shallow copy of the array to avoid modifying the original array
              .sort((a: any, b: any) => {
                let nameA: string = a["rawMaterialGradeCode"]!.toUpperCase(); // ignore upper and lowercase
                let nameB: string = b["rawMaterialGradeCode"]!.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                  return -1;
                }
                if (nameA > nameB) {
                  return 1;
                }
                return 0;
              })
              .slice(0, 100);
          }

          const autoSelectedGrade = this.getSingleAutoSelectableRawMaterialGrade(this.enquiryForm[_i].autoCompleteDataset as RawMaterialGrade[]);
          if (autoSelectedGrade) {
            this.enquiryForm[_i].value = autoSelectedGrade.rawMaterialGradeId;
            this.enquiryForm[_i].text = autoSelectedGrade.rawMaterialGradeCode;
          }
        } else {
          this.enquiryForm[_i].disabled = true;
          this.enquiryForm[_i].value = null;
          this.enquiryForm[_i].text = null;
          //this.teiasoftToaster.show("info", this.translate.instant("enquiryBook.noRawMaterials"));
        }

      }
    }));
  }

  getRawMaterialGrades(value: string, normGradeIds: number[]) {
    this.subscriptions.add(this.backendService.getRawMaterialGradesForEnquiry(normGradeIds).subscribe(res => {
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'rawMaterialGrades');
      if (res && res.rawMaterialGrades!.length > 0) {
        this.enquiryForm[_i].disabled = false;
        this.enquiryForm[_i].autoCompleteDataset = new Array();
        let rawMaterialGrades = res.rawMaterialGrades;
        if (value != '') {
          rawMaterialGrades = rawMaterialGrades!.filter(x => x.toLowerCase().includes(value.toLowerCase()));
        }
        for (var x = 0; x < rawMaterialGrades!.length; x++) {
          let _item: RawMaterialGrade = new RawMaterialGrade();
          _item.rawMaterialGradeCode = rawMaterialGrades![x];
          _item.rawMaterialGradeId = x;
          _item.isDefault = false;
          this.enquiryForm[_i].autoCompleteDataset!.push(_item);
        }

        if (this.enquiryForm[_i].autoCompleteDataset!.length == 1) {
          this.enquiryForm[_i].value = this.enquiryForm[_i].autoCompleteDataset![0]["rawMaterialGradeId"];
          this.enquiryForm[_i].text = this.enquiryForm[_i].autoCompleteDataset![0]["rawMaterialGradeCode"];
        }

        //MQF-401
        this.enquiryForm[_i].isRequired = true;

        /* this.enquiryForm[_i].optionsList = new Array();
        for (var x=0; x < res.rawMaterialGrades!.length; x++){
          let _item: SelectOption = new SelectOption();
          _item.text = res.rawMaterialGrades![x];
          _item.value = res.rawMaterialGrades![x];
          this.enquiryForm[_i].optionsList!.push(_item);
        } */

        // Se restituisce un solo valore lo passo alla select
        /* if (this.enquiryForm[_i].optionsList!.length == 1){
          this.enquiryForm[_i].value = this.enquiryForm[_i].optionsList![0];
          this.enquiryForm[_i].text = this.enquiryForm[_i].optionsList![0];
        } */
      } else {
        this.enquiryForm[_i].disabled = true;
        this.enquiryForm[_i].value = null;
        this.enquiryForm[_i].text = null;
        //MQF-401
        this.enquiryForm[_i].isRequired = false;
      }
    }));
  }

  private getSingleAutoSelectableRawMaterialGrade(rawMaterialGrades?: RawMaterialGrade[] | null): RawMaterialGrade | undefined {
    const selectableGrades = (rawMaterialGrades || []).filter(rawMaterialGrade => rawMaterialGrade?.isDummy !== true);
    return selectableGrades.length === 1 ? selectableGrades[0] : undefined;
  }

  getNormGrades(value: string): Promise<void> {
    return new Promise<void>((resolve) => {
      this.subscriptions.add(this.backendService.getNormGrades([]).subscribe(res => {
        if (res && res.normGrades) {
          if (!this.enquiryForm || this.enquiryForm.length == 0) {
            this.dataSetNormGrades = new Array();
            this.dataSetNormGrades = res.normGrades;
            return;
          }

          let _i: number = this.enquiryForm.findIndex(x => x.field == 'normGrades');
          this.enquiryForm[_i].autoCompleteDataset = new Array();
          if (value != '') {
            this.enquiryForm[_i].autoCompleteDataset = [
              ...res.normGrades.filter(x => x.normGradeCode!.toLowerCase().startsWith(value.toLowerCase())).sort((a, b) => a.normGradeCode!.localeCompare(b.normGradeCode!)),
              ...res.normGrades.filter(x =>
                x.normGradeCode!.toLowerCase().includes(value!.toLowerCase()) &&
                !x.normGradeCode!.toLowerCase().startsWith(value!.toLowerCase())
              ).sort((a, b) => a.normGradeCode!.localeCompare(b.normGradeCode!))
            ];
          } else {

            // MQF-370 - Obsolete - GBR 12/07/2024
            let _exists: boolean = true;
            let _idsToRemove: number[] = new Array();
            if (this.enquiryToEdit && this.enquiryToEdit.header && this.enquiryToEdit.header.normGrades && this.enquiryToEdit.header.normGrades.length > 0) {
              for (var x = 0; x < this.enquiryToEdit.header!.normGrades.length; x++) {
                _exists = res.normGrades!.findIndex(n => n.normGradeId == this.enquiryToEdit.header!.normGrades![x].normGradeId) != -1; // MQF-377

                // Se la norm grade associata non è presente nei 100 la aggiungo (ma solo se esiste nel db) -- MQF-370
                if (_exists && this.enquiryForm[_i].autoCompleteDataset!.findIndex(n => n.normGradeId == this.enquiryToEdit.header!.normGrades![x].normGradeId) == -1)
                  this.enquiryForm[_i].autoCompleteDataset!.unshift(this.enquiryToEdit.header.normGrades[x]);

                // MQF-370 - In caso di duplicate e NormGrade non esistente la tolgo
                if (_exists == false) {
                  _idsToRemove.push(this.enquiryToEdit.header.normGrades[x].normGradeId!);
                }
              }

              if (_idsToRemove.length > 0) {
                for (var k = 0; k < _idsToRemove.length; k++) {
                  this.enquiryToEdit.header.normGrades = this.enquiryToEdit.header.normGrades!.filter(i => i.normGradeId != _idsToRemove[k]);
                }
                if (this.enquiryToEdit.header.normGrades.length == 0) {
                  this.enquiryForm[_i].value = "";
                  this.enquiryForm[_i].text = "";
                  // Disabilito RawMaterial Grade
                  _i = this.enquiryForm.findIndex(x => x.field == "rawMaterialGrades");
                  this.enquiryForm[_i].disabled = true;
                }
              }
            }

            // END 

            this.enquiryForm[_i].autoCompleteDataset = res.normGrades!
              .slice() // Create a shallow copy of the array to avoid modifying the original array
              .sort((a: any, b: any) => {
                let nameA: string = a["normGradeCode"]!.toUpperCase(); // ignore upper and lowercase
                let nameB: string = b["normGradeCode"]!.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                  return -1;
                }
                if (nameA > nameB) {
                  return 1;
                }
                // names must be equal
                return 0;
              }) // Sort by the 'score' property in descending order
              .slice(0, 100); // Take the top 100 records

            // Se sono in edit e la norm grade associata non è presente nei 100 la aggiungo (ma solo se esiste nel db) -- MQF-370
            /* if (this.enquiryToEdit && this.enquiryToEdit.header && this.enquiryToEdit.header.normGrades && this.enquiryToEdit.header.normGrades!.length > 0){
              for (var x=0; x < this.enquiryToEdit.header.normGrades!.length; x++){
                if (_exists && this.enquiryForm[_i].autoCompleteDataset!.findIndex(n => n.normGradeId == this.enquiryToEdit.header!.normGrades![x].normGradeId) == -1)
                  this.enquiryForm[_i].autoCompleteDataset!.unshift(this.enquiryToEdit.header.normGrades[x]);
              }
            } */

            // MQF-370 - In caso di duplicate e NormGrade non esistente la tolgo
            /* if (this.isDuplicate && _exists == false){
              this.enquiryForm[_i].value = "";
              this.enquiryForm[_i].text = "";
              // Disabilito RawMaterial Grade
              _i = this.enquiryForm.findIndex(x => x.field == "rawMaterialGrades");
              this.enquiryForm[_i].disabled = true;
            } */
          }
        }
        resolve();
      }));
    });

  }

  getOfferValidityOptions(): SelectOption[] | undefined {
    return this.headerParametersValues.offerValidities?.map((ov: any) => {
      let sc = new SelectOption();
      sc.isDefault = ov.isDefault;
      sc.text = ov[this.translate.currentLang];
      sc.value = ov.id;
      return sc;
    })
  }

  getOfferSchemes(): SelectOption[] {
    const defaultOptions: SelectOption[] = [];
    const otherOptions: SelectOption[] = [];

    for (const offerScheme of (this.headerParametersValues.offerSchemes ?? []) as OfferScheme[]) {
      let _item: SelectOption = new SelectOption();
      _item.text = offerScheme.offerSchemeDescription ?? offerScheme.offerSchemeCode!;
      _item.value = offerScheme.offerSchemeCode;
      _item.isDefault = offerScheme.isDefault;

      if (offerScheme.isDefault) {
        defaultOptions.push(_item);
      } else {
        otherOptions.push(_item);
      }
    }

    return [...defaultOptions, ...otherOptions];
  }

  getBonusSchemes(): SelectOption[] {
    const defaultOptions: SelectOption[] = [];
    const otherOptions: SelectOption[] = [];

    for (const bonusScheme of (this.headerParametersValues.bonusSchemes ?? []) as BonusScheme[]) {
      let _item: SelectOption = new SelectOption();
      _item.text = bonusScheme.bonusSchemeDescription ?? bonusScheme.bonusSchemeCode!;
      _item.value = bonusScheme.bonusSchemeCode;
      _item.isDefault = bonusScheme.isDefault;

      if (bonusScheme.isDefault) {
        defaultOptions.push(_item);
      } else {
        otherOptions.push(_item);
      }
    }

    return [...defaultOptions, ...otherOptions];
  }

  getUoms(uom: string): SelectOption[] {
    let _list: SelectOption[] = new Array();
    let _i: number = this.enquiryForm.findIndex(x => x.field == 'unitSystem');
    let _unitSystem: string = "";
    if (_i != -1) {
      _unitSystem = this.enquiryForm[_i].value!;
      if (_unitSystem != '') {
        for (const prop in this.headerParametersValues) {
          if (prop.toString() == uom) {
            let _uoms: UomsType = new UomsType();
            _uoms = this.headerParametersValues[prop as keyof HeaderParametersValues] as UomsType;
            if (_unitSystem.toLowerCase() == 'metric') {
              for (var x = 0; x < _uoms.metricUoms!.length; x++) {
                let _item: SelectOption = new SelectOption();
                _item.text = _uoms.metricUoms![x].uomCode!;
                _item.value = _uoms.metricUoms![x].uomCode!;
                _item.isDefault = _uoms.metricUoms![x].isDefault;
                if (!_uoms.metricUoms![x].isDefault)
                  _list.push(_item);
                else
                  _list.unshift(_item);
              }
            } else {
              for (var x = 0; x < _uoms.imperialUoms!.length; x++) {
                let _item: SelectOption = new SelectOption();
                _item.text = _uoms.imperialUoms![x].uomCode!;
                _item.value = _uoms.imperialUoms![x].uomCode!;
                _item.isDefault = _uoms.imperialUoms![x].isDefault;
                if (!_uoms.imperialUoms![x].isDefault)
                  _list.push(_item);
                else
                  _list.unshift(_item);
              }
            }
          }
        }

        // Se ho settato gli NPS devo modificare i valori delle OD/WT
        _i = this.enquiryForm.findIndex(x => x.field == 'npsDescription');
        if (this.enquiryForm[_i].value != '' && this.enquiryForm[_i].value != null) {
          let _npsId = parseInt(this.enquiryForm[_i].value);
          if (this.dataSetNps && this.dataSetNps.length > 0) {
            if (_unitSystem.toLowerCase() == 'metric') {
              _i = this.enquiryForm.findIndex(x => x.field == 'od');
              this.enquiryForm[_i].value = this.dataSetNps.filter(x => parseInt(x["npsScheduleId"]) == _npsId)[0]["odMetric"];
              this.enquiryForm[_i].text = this.enquiryForm[_i].value;

              _i = this.enquiryForm.findIndex(x => x.field == 'wt');
              this.enquiryForm[_i].value = this.dataSetNps.filter(x => parseInt(x["npsScheduleId"]) == _npsId)[0]["wtMetric"];
              this.enquiryForm[_i].text = this.enquiryForm[_i].value;
            } else {
              _i = this.enquiryForm.findIndex(x => x.field == 'od');
              this.enquiryForm[_i].value = this.dataSetNps.filter(x => parseInt(x["npsScheduleId"]) == _npsId)[0]["odImperial"];
              this.enquiryForm[_i].text = this.enquiryForm[_i].value;

              _i = this.enquiryForm.findIndex(x => x.field == 'wt');
              this.enquiryForm[_i].value = this.dataSetNps.filter(x => parseInt(x["npsScheduleId"]) == _npsId)[0]["wtImperial"];
              this.enquiryForm[_i].text = this.enquiryForm[_i].value;
            }
          }
        }
      }
    }

    return _list;
  }

  getAlloySurcharge(): SelectOption[] {
    let _list: SelectOption[] = new Array();
    let _item: SelectOption = new SelectOption();
    _item.text = this.translate.instant("noTranslations.yes");
    _item.value = true;
    _list.push(_item);
    _item = new SelectOption();
    _item.text = this.translate.instant("noTranslations.no");
    _item.value = false;
    _list.push(_item);
    return _list;
  }

  getSmsMarketingRoute(): SelectOption[] {
    if (!this.headerParametersValues || !this.headerParametersValues.sms) return [];

    let _list: SelectOption[] = new Array();

    let marketingRoutes = [...new Set(this.headerParametersValues.sms!.map(sms => sms.marketingRoute))];

    for (var x = 0; x < marketingRoutes.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = marketingRoutes[x];
      _item.value = marketingRoutes[x];
      _list.push(_item);
    }
    return _list;
  }

  getSms(marketingRoute: string | null = null): SelectOption[] {
    if (!this.headerParametersValues || !this.headerParametersValues.sms) return [];
    let _list: SelectOption[] = new Array();

    let sms = [...this.headerParametersValues.sms!];

    if (marketingRoute)
      sms = sms.filter(s => s.marketingRoute === marketingRoute);

    for (var x = 0; x < sms.length; x++) {
      let _item: SelectOption = new SelectOption();
      _item.text = sms[x].description;
      _item.value = sms[x].smsId;
      _list.push(_item);
    }
    return _list;
  }

  refreshFullGrid() {
    this.refreshGridKey++;
  }

  // MQF-381 aggiunto flag per apertura modale
  getNpsAndSchedules(showModal: boolean) {
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.getNpsAndSchedules().subscribe(res => {
      this.teiasoftLoader.stop();
      this.dataSetNps = new Array();
      if (res) {
        this.dataSetNps = this.utils.sortNpSAndSchedule(res.npsSchedules!); // MQF-150
        for (var x = 0; x < this.dataSetNps.length; x++) {
          let obj: any = this.dataSetNps[x];
          for (const key in obj) {
            if (typeof obj[key] == 'number') {
              if (key.toLowerCase() != 'npsscheduleid') {
                let _digits: number = 2;
                let _col: string = key.substring(0, 2);
                if (key.indexOf("Metric") != -1 && this.roundDigitsForEnquiryForm!.filter(x => x.fieldName == _col)[0]) {
                  _digits = this.roundDigitsForEnquiryForm!.filter(r => r.fieldName == _col)[0].metricDigits!;
                }
                if (key.indexOf("Imperial") != -1 && this.roundDigitsForEnquiryForm!.filter(x => x.fieldName == _col)[0]) {
                  _digits = this.roundDigitsForEnquiryForm!.filter(r => r.fieldName == _col)[0].imperialDigits!;
                }
                this.dataSetNps[x][key] = this.dataSetNps[x][key].toFixed(_digits); // Number(this.dataSetNps[x][key].toFixed(4));
              }
              //this.dataSetNps[x][key] = this.dataSetNps[x][key].toFixed(4); // Number(this.dataSetNps[x][key].toFixed(4));
            }
          }

          // Adding Uoms
          let _metricUom: string = "metricUom";
          this.dataSetNps[x][_metricUom as string] = 'mm';

          let _imperialUom: string = "imperialUom";
          this.dataSetNps[x][_imperialUom as string] = 'in';
        }
        if (showModal == true) this.showSelectNps = true;
      }
    }));
  }

  getCustomers() {
    this.dataSetCustomers = new Array();
    this.dataSetCustomers = this.headerParametersValues.customers!;
    this.showSelectCustomer = true;
  }

  setSelectUoms() {
    const fields = [
      { field: 'odUom', uomsKey: 'odUoms', labelField: 'od' },
      { field: 'idUom', uomsKey: 'idUoms', labelField: 'id' },
      { field: 'wtUom', uomsKey: 'wtUoms', labelField: 'wt' },
      { field: 'totalWeightUom', uomsKey: 'totalWeightUoms' },
    ];

    fields.forEach(({ field, uomsKey, labelField }) => {
      const index = this.enquiryForm.findIndex(x => x.field === field);
      if (index === -1) return;

      const formField = this.enquiryForm[index];
      formField.value = '';
      formField.text = '';
      formField.optionsList = this.getUoms(uomsKey) || [];

      if (!formField.disabled && formField.optionsList.length > 0) {
        const defaultOption = formField.optionsList.find(option => option.isDefault);
        formField.value = defaultOption ? defaultOption.value : '';
      }

      // Update label field
      const labelIndex = this.enquiryForm.findIndex(x => x.field === labelField);
      if (labelIndex !== -1) {
        const labelFieldEntry = this.enquiryForm[labelIndex];
        labelFieldEntry.labelText = labelFieldEntry.labelText!.replace(/\s*\(.*?\)$/, '');
        labelFieldEntry.labelText = labelFieldEntry.labelText + (formField.value ? ` (${formField.value})` : '')
      }
    });
  }


  private checkItdcrResultsBeforeAction(enquiryNo: string, action: 'revision') {
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.hasEnquiryItdcrResults(enquiryNo).subscribe({
      next: (res) => {
        this.teiasoftLoader.stop();
        if (res?.hasEnquiryItdcrResults) {
          this.teiasoftModalService.show(
            'confirm',
            this.translate.instant('enquiryBook.keepItdcrResultsTitle'),
            this.translate.instant('enquiryBook.keepItdcrResultsMessage'),
            { enquiryNo, action },
            'confirmKeepItdcrResults',
            false,
            undefined,
            'declineKeepItdcrResults'
          );
          return;
        }

        this.proceedWithItdcrResultsChoice(enquiryNo, false);
      },
      error: () => {
        this.teiasoftLoader.stop();
        this.proceedWithItdcrResultsChoice(enquiryNo, false);
      }
    }));
  }

  private proceedWithItdcrResultsChoice(enquiryNo: string, keepItdcrResults: boolean) {
    this.startEditFlowWithChangeCheck(enquiryNo, false, keepItdcrResults, true).then(() => this.refreshFullGrid());
  }

  private checkItdcrResultsBeforeDuplicateCreation(enquiry: CreateEnquiry, action: string, attachments: AttachmentToUpdate[]) {
    if (!this.sourceEnquiryNo) {
      enquiry.keepItdcrResults = false;
      this.checkForSimilarEnquiriesAndCreateEnquiry(enquiry, action, attachments);
      return;
    }

    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.hasEnquiryItdcrResults(this.sourceEnquiryNo).subscribe({
      next: (res) => {
        this.teiasoftLoader.stop();
        if (res?.hasEnquiryItdcrResults) {
          this.pendingDuplicateEnquiry = enquiry;
          this.pendingDuplicateAction = action;
          this.pendingDuplicateAttachments = attachments;
          this.teiasoftModalService.show(
            'confirm',
            this.translate.instant('enquiryBook.keepItdcrResultsTitle'),
            this.translate.instant('enquiryBook.keepItdcrResultsMessage'),
            { action: 'duplicate-save' },
            'confirmKeepItdcrResults',
            false,
            undefined,
            'declineKeepItdcrResults'
          );
          return;
        }

        enquiry.keepItdcrResults = false;
        this.checkForSimilarEnquiriesAndCreateEnquiry(enquiry, action, attachments);
      },
      error: () => {
        this.teiasoftLoader.stop();
        enquiry.keepItdcrResults = false;
        this.checkForSimilarEnquiriesAndCreateEnquiry(enquiry, action, attachments);
      }
    }));
  }

  private checkItdcrResultsBeforeReopen(rs: RevisionSavePayload) {
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.hasEnquiryItdcrResults(rs.enquiryNo).subscribe({
      next: (res) => {
        this.teiasoftLoader.stop();
        if (res?.hasEnquiryItdcrResults) {
          this.pendingReopenRevision = rs;
          this.teiasoftModalService.show(
            'confirm',
            this.translate.instant('enquiryBook.keepItdcrResultsTitle'),
            this.translate.instant('enquiryBook.keepItdcrResultsMessage'),
            { action: 'reopen' },
            'confirmKeepItdcrResults',
            false,
            undefined,
            'declineKeepItdcrResults'
          );
          return;
        }

        this.proceedWithReopenChoice(rs, false);
      },
      error: () => {
        this.teiasoftLoader.stop();
        this.proceedWithReopenChoice(rs, false);
      }
    }));
  }

  private proceedWithReopenChoice(rs: RevisionSavePayload, keepItdcrResults: boolean) {
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.enquiryReOpen(rs.enquiryNo, rs.customerRequestDate, keepItdcrResults).subscribe({
      next: (res) => {
        this.refreshFullGrid();
        this.openReopenFlowInEdit(res.newRevisionEnquiryNo || rs.enquiryNo, !!res?.hasPriceOrMarginChanges);
      },
      error: () => {
        this.teiasoftLoader.stop();
        // this.teiasoftToaster.show("error", this.translate.instant('errors.failedToSaveRevision'));
      },
      complete: () => { this.showReopenModal = false; }
    }));
  }

  editAndCreateVersionIfNecessary(enquiryNo: string, showAIDialog: boolean = false, keepItdcrResults?: boolean): Promise<any> {
    this.teiasoftLoader.start();
    return new Promise((resolve, reject) => {
      this.subscriptions.add(this.backendService.editAndCreateVersionIfNecessary(enquiryNo, keepItdcrResults).subscribe({
        next: (res) => {
          if (!res.enquiryNo || res.enquiryNo == '') {
            this.teiasoftModalService.show('error', this.translate.instant("enquiryBook.edit"), this.translate.instant("errors.malformedData"), null, '');
            this.teiasoftLoader.stop();
            reject(null);
            return;
          }
          this.openEnquiryForEditing(res, showAIDialog, false);
          this.teiasoftLoader.stop();
          resolve(this.enquiryToEdit);
        },
        error: (err) => {
          this.teiasoftLoader.stop();
          reject(err);
        }
      }))
    });
  }

  private startEditFlowWithChangeCheck(enquiryNo: string, showAIDialog: boolean = false, keepItdcrResults?: boolean, allowReverseOnChanges: boolean = true): Promise<Enquiry | null> {
    this.teiasoftLoader.start();
    return new Promise((resolve, reject) => {
      this.subscriptions.add(this.backendService.editAndCreateVersionIfNecessary(enquiryNo, keepItdcrResults).subscribe({
        next: (res) => {
          if (!res.enquiryNo || res.enquiryNo == '') {
            this.teiasoftModalService.show('error', this.translate.instant("enquiryBook.edit"), this.translate.instant("errors.malformedData"), null, '');
            this.teiasoftLoader.stop();
            reject(null);
            return;
          }

          if (res.hasPriceOrMarginChanges) {
            this.openPriceMarginChangesFlow(res, allowReverseOnChanges, showAIDialog);
            this.teiasoftLoader.stop();
            resolve(res);
            return;
          }

          this.openEnquiryForEditing(res, showAIDialog, false);
          this.teiasoftLoader.stop();
          resolve(res);
        },
        error: (err) => {
          this.teiasoftLoader.stop();
          reject(err);
        }
      }));
    });
  }

  private openReopenFlowInEdit(enquiryNo: string, hasPriceOrMarginChanges: boolean) {
    this.subscriptions.add(this.backendService.editAndCreateVersionIfNecessary(enquiryNo).subscribe({
      next: (res) => {
        if (!res.enquiryNo || res.enquiryNo == '') {
          this.teiasoftModalService.show('error', this.translate.instant("enquiryBook.edit"), this.translate.instant("errors.malformedData"), null, '');
          return;
        }

        if (hasPriceOrMarginChanges || !!res.hasPriceOrMarginChanges) {
          this.openPriceMarginChangesFlow(res, true, false);
          return;
        }

        this.openEnquiryForEditing(res, false, false);
      },
      error: () => { this.teiasoftLoader.stop(); },
      complete: () => this.teiasoftLoader.stop()
    }));
  }

  private openPriceMarginChangesFlow(enquiry: Enquiry, allowReverse: boolean, showAIDialog: boolean) {
    this.pendingPriceMarginEnquiry = JSON.parse(JSON.stringify(enquiry));
    this.priceMarginChangesEnquiryNo = enquiry.enquiryNo || '';
    this.priceMarginChangesMasterItems = JSON.parse(JSON.stringify(enquiry.items || []));
    this.priceMarginChangesAllowReverse = allowReverse;
    this.priceMarginChangesShowAIDialog = showAIDialog;
    this.showPriceMarginChangesModal = true;
  }

  private openEnquiryForEditing(enquiry: Enquiry, showAIDialog: boolean = false, openEditPrices: boolean = false) {
    this.enquiryToEdit = new Enquiry();
    this.enquiryToEdit = enquiry;
    if (this.enquiryToEdit.header) {
      this.enquiryToEdit.header.totalWeight = this.enquiryToEdit.header.totalWeight != null
        ? parseFloat(this.enquiryToEdit.header.totalWeight.toFixed(4).toString())
        : null;
    }

    this.buildAddEnquiryForm('edit');
    this.showUploadFromAI = showAIDialog;
    this.openEditPricesTrigger = openEditPrices ? Date.now() : 0;
    this.showEditEnquiry = true;
  }

  onPriceMarginChangesGoToOverview() {
    if (!this.pendingPriceMarginEnquiry) {
      this.showPriceMarginChangesModal = false;
      return;
    }
    const enquiry = JSON.parse(JSON.stringify(this.pendingPriceMarginEnquiry)) as Enquiry;
    const showAIDialog = this.priceMarginChangesShowAIDialog;
    this.resetPriceMarginChangesFlow();
    this.openEnquiryForEditing(enquiry, showAIDialog, false);
  }

  onPriceMarginChangesGoToEditPrices() {
    if (!this.pendingPriceMarginEnquiry) {
      this.showPriceMarginChangesModal = false;
      return;
    }
    const enquiry = JSON.parse(JSON.stringify(this.pendingPriceMarginEnquiry)) as Enquiry;
    const showAIDialog = this.priceMarginChangesShowAIDialog;
    this.resetPriceMarginChangesFlow();
    this.openEnquiryForEditing(enquiry, showAIDialog, true);
  }

  onPriceMarginChangesReverse() {
    if (!this.priceMarginChangesAllowReverse || !this.priceMarginChangesEnquiryNo) {
      return;
    }
    const enquiryNo = this.priceMarginChangesEnquiryNo;
    this.resetPriceMarginChangesFlow();
    this.discardEnquiryEdit(enquiryNo);
  }

  private resetPriceMarginChangesFlow() {
    this.showPriceMarginChangesModal = false;
    this.priceMarginChangesEnquiryNo = "";
    this.priceMarginChangesMasterItems = [];
    this.priceMarginChangesAllowReverse = false;
    this.priceMarginChangesShowAIDialog = false;
    this.pendingPriceMarginEnquiry = null;
  }

  discardEnquiryEdit(enquiryNo: string) {
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.discardEnquiryEdit(enquiryNo).subscribe(res => {
      this.teiasoftLoader.stop();
      this.showEditEnquiry = false;
      this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
      this.refreshFullGrid();
    }));
  }

  closeEnquiryEditingSession(enquiryNo: string, freezeEnquiry?: FreezeEnquiry) {
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.closeEnquiryEditingSession(enquiryNo, freezeEnquiry).subscribe(res => {
      this.teiasoftLoader.stop();
      this.showEditEnquiry = false;
      this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
      this.refreshFullGrid();
      this.onSearchForSimilarEnquiries(enquiryNo);
    }, (_err) => {
      this.refreshFullGrid();
    }));
  }

  enquiryClose(parameter: string) {
    let _data: CloseEnquiryData = new CloseEnquiryData();
    _data = JSON.parse(parameter);
    if (_data.lostReasonId!.toString() == '') _data.lostReasonId = null;
    this.teiasoftLoader.start();
    this.subscriptions.add(this.backendService.enquiryClose(_data).subscribe(res => {
      this.teiasoftLoader.stop();
      this.showCloseEnquiry = false;
      this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
      this.refreshFullGrid();
    }, (_err) => {
      this.refreshFullGrid();
      this.showCloseEnquiry = false;
    }));
  }

  checkWtOdId_OLD() {
    let _iOd: number = this.enquiryForm.findIndex(x => x.field!.toLowerCase() === 'od');
    let _iOdUom: number = this.enquiryForm.findIndex(x => x.field!.toLowerCase() === 'oduom');
    let _odValue: any = this.enquiryForm[_iOd].value ? this.enquiryForm[_iOd].value : '';

    let _iId: number = this.enquiryForm.findIndex(x => x.field!.toLowerCase() === 'id');
    let _iIdUom: number = this.enquiryForm.findIndex(x => x.field!.toLowerCase() === 'iduom');
    let _idValue: any = this.enquiryForm[_iId].value ? this.enquiryForm[_iId].value : '';

    let _iWt: number = this.enquiryForm.findIndex(x => x.field!.toLowerCase() === 'wt');
    let _iWtUom: number = this.enquiryForm.findIndex(x => x.field!.toLowerCase() === 'wtuom');
    let _wtValue: any = this.enquiryForm[_iWt].value ? this.enquiryForm[_iWt].value : '';

    if (_odValue != '' && _idValue == '' && _wtValue == '') {
      this.enquiryForm[_iOd].isRequired = true;
      this.enquiryForm[_iOd].isValid = true;
      this.enquiryForm[_iOdUom].isRequired = true;
      this.enquiryForm[_iId].isRequired = true;
      this.enquiryForm[_iId].isValid = false;
      this.enquiryForm[_iIdUom].isRequired = true;
      this.enquiryForm[_iWt].isRequired = true;
      this.enquiryForm[_iWt].isValid = false;
      this.enquiryForm[_iWtUom].isRequired = true;
    }

    if (_odValue == '' && _idValue != '' && _wtValue == '') {
      this.enquiryForm[_iOd].isRequired = true;
      this.enquiryForm[_iOd].isValid = false;
      this.enquiryForm[_iOdUom].isRequired = true;
      this.enquiryForm[_iId].isRequired = true;
      this.enquiryForm[_iId].isValid = true;
      this.enquiryForm[_iIdUom].isRequired = true;
      this.enquiryForm[_iWt].isRequired = true;
      this.enquiryForm[_iWt].isValid = false;
      this.enquiryForm[_iWtUom].isRequired = true;
    }

    if (_odValue == '' && _idValue == '' && _wtValue != '') {
      this.enquiryForm[_iOd].isRequired = true;
      this.enquiryForm[_iOd].isValid = false;
      this.enquiryForm[_iOdUom].isRequired = true;
      this.enquiryForm[_iId].isRequired = true;
      this.enquiryForm[_iId].isValid = false;
      this.enquiryForm[_iIdUom].isRequired = true;
      this.enquiryForm[_iWt].isRequired = true;
      this.enquiryForm[_iWt].isValid = true;
      this.enquiryForm[_iWtUom].isRequired = true;
    }

    if (_odValue != '' && _idValue != '' && _wtValue == '') {
      this.enquiryForm[_iOd].isRequired = true;
      this.enquiryForm[_iOd].isValid = true;
      this.enquiryForm[_iOdUom].isRequired = true;
      this.enquiryForm[_iOdUom].value = this.enquiryForm[_iOdUom].optionsList![0].value!;
      this.enquiryForm[_iOdUom].text = this.enquiryForm[_iOdUom].optionsList![0].text!;
      this.enquiryForm[_iId].isRequired = true;
      this.enquiryForm[_iId].isValid = true;
      this.enquiryForm[_iIdUom].isRequired = true;
      this.enquiryForm[_iIdUom].value = this.enquiryForm[_iIdUom].optionsList![0].value!;
      this.enquiryForm[_iIdUom].text = this.enquiryForm[_iIdUom].optionsList![0].text!;
      this.enquiryForm[_iWt].isRequired = false;
      this.enquiryForm[_iWt].isValid = true;
      this.enquiryForm[_iWtUom].isRequired = false;
      this.enquiryForm[_iWtUom].value = '';
      this.enquiryForm[_iWtUom].text = '';
      this.enquiryForm[_iWtUom].isValid = true;
    }

    if (_odValue == '' && _idValue != '' && _wtValue != '') {
      this.enquiryForm[_iOd].isRequired = false;
      this.enquiryForm[_iOd].isValid = true;
      this.enquiryForm[_iOdUom].isRequired = false;
      this.enquiryForm[_iOdUom].value = '';
      this.enquiryForm[_iOdUom].text = '';
      this.enquiryForm[_iOdUom].isValid = true;
      this.enquiryForm[_iId].isRequired = true;
      this.enquiryForm[_iId].isValid = true;
      this.enquiryForm[_iIdUom].isRequired = true;
      this.enquiryForm[_iIdUom].value = this.enquiryForm[_iIdUom].optionsList![0].value!;
      this.enquiryForm[_iIdUom].text = this.enquiryForm[_iIdUom].optionsList![0].text!;
      this.enquiryForm[_iWt].isRequired = true;
      this.enquiryForm[_iWt].isValid = true;
      this.enquiryForm[_iWtUom].isRequired = true;
      this.enquiryForm[_iWtUom].value = this.enquiryForm[_iWtUom].optionsList![0].value!;
      this.enquiryForm[_iWtUom].text = this.enquiryForm[_iWtUom].optionsList![0].text!;
    }

    if (_odValue != '' && _idValue == '' && _wtValue != '') {
      this.enquiryForm[_iOd].isRequired = true;
      this.enquiryForm[_iOd].isValid = true;
      this.enquiryForm[_iOdUom].isRequired = true;
      this.enquiryForm[_iOdUom].value = this.enquiryForm[_iOdUom].optionsList![0].value!;
      this.enquiryForm[_iOdUom].text = this.enquiryForm[_iOdUom].optionsList![0].text!;
      this.enquiryForm[_iId].isRequired = false;
      this.enquiryForm[_iId].isValid = true;
      this.enquiryForm[_iIdUom].isRequired = false;
      this.enquiryForm[_iIdUom].value = '';
      this.enquiryForm[_iIdUom].text = '';
      this.enquiryForm[_iIdUom].isValid = true;
      this.enquiryForm[_iWt].isRequired = true;
      this.enquiryForm[_iWt].isValid = true;
      this.enquiryForm[_iWtUom].isRequired = true;
      this.enquiryForm[_iWtUom].value = this.enquiryForm[_iWtUom].optionsList![0].value!;
      this.enquiryForm[_iWtUom].text = this.enquiryForm[_iWtUom].optionsList![0].text!;
    }

    // Caso in cui tutti sono compilati (allora metto tutte le uom mandatory)
    if (_odValue != '' && _idValue != '' && _wtValue != '') {
      this.enquiryForm[_iOdUom].isRequired = true;
      this.enquiryForm[_iOdUom].value = this.enquiryForm[_iOdUom].optionsList![0].value!;
      this.enquiryForm[_iOdUom].text = this.enquiryForm[_iOdUom].optionsList![0].text!;
      this.enquiryForm[_iIdUom].isRequired = true;
      this.enquiryForm[_iIdUom].value = this.enquiryForm[_iIdUom].optionsList![0].value!;
      this.enquiryForm[_iIdUom].text = this.enquiryForm[_iIdUom].optionsList![0].text!;
      this.enquiryForm[_iWtUom].isRequired = true;
      this.enquiryForm[_iWtUom].value = this.enquiryForm[_iWtUom].optionsList![0].value!;
      this.enquiryForm[_iWtUom].text = this.enquiryForm[_iWtUom].optionsList![0].text!;
    }
  }

  getItemsByEnquiryNo(enquiryNo: string) {
    this.teiasoftLoader.start();
    this.pendingExpandedTotalsEnquiryNo = enquiryNo;
    this.resetExpandedEnquiryTotals();
    this.subscriptions.add(this.backendService.getItemsByEnquiryNo(enquiryNo).subscribe({
      next: res => {
        this.enquiryItems = new ItemsByEnquiryNo();
        this.enquiryItems = res;
        this.fillDataSetItems(res);
        this.loadExpandedEnquiryTotals(enquiryNo);

        this.expandedEnquiryNo = null;
        this.cdr.detectChanges();

        this.expandedEnquiryNo = enquiryNo;
        this.cdr.detectChanges();
      },
      error: () => {
        this.pendingExpandedTotalsEnquiryNo = null;
        this.resetExpandedEnquiryTotals();
        this.teiasoftLoader.stop();
      }
    }));
  }

  fillDataSetItems(enquiryItems: ItemsByEnquiryNo) {
    this.dataSetItems = new Array();
    for (var i = 0; i < enquiryItems.items!.length; i++) {
      let _dataSet: GridDataset = new GridDataset();
      let _obj: Items = new Items();
      _obj = enquiryItems.items![i]!;
      for (const key in _obj) {
        let _value: any = _obj[key as keyof typeof _obj];
        if (_value == null) _value = "";
        let _typeOf: string = typeof _value;
        let _key: string = "";
        if (_typeOf != 'object') {
          _dataSet[key] = _value;
        } else {
          if (Array.isArray(_value)) {
            _key = key;
            if (_value.length == 0) {
              _dataSet[_key] = '';
            }
            if (_value.length > 0 && key.toLowerCase() == 'attachments') {
              _dataSet[_key] = _value.length;
            } else {
              for (const key2 in _value[0]) {
                _key = key + "." + key2;
                //_dataSet[key2] = _value.map(x => x[key2]).join(',');
                _dataSet[_key] = _value.map(x => x[key2]).join(',');
              }
            }

          } else {
            for (const key3 in _value) {
              if (typeof _value[key3] != 'object') {
                _key = key + "." + key3;
                let _value3: any = _value[key3 as keyof typeof _value];
                //_dataSet[key3] = _value3;
                _dataSet[_key] = _value3;
              } else {
                for (const key4 in _value[key3]) {
                  _key = key + "." + key3 + "." + key4;
                  let _value4: any = _value[key3][key4]; //_value[key4 as keyof typeof key4];
                  //_dataSet[key4] = _value4;
                  _dataSet[_key] = _value4;
                }
              }
            }
          }
        }
      }
      this.dataSetItems.push(_dataSet);
    }

    this.dataSetItems = this.dataSetItems.sort(
      function (a, b) {
        return a["itemNo"]! - b["itemNo"]!;
      }
    );
    this.teiasoftLoader.stop();
  }

  hasExpandedEnquiryTotals(): boolean {
    return !!this.expandedEnquiryTotals;
  }

  private loadExpandedEnquiryTotals(enquiryNo: string): void {
    this.subscriptions.add(this.backendService.getEnquiryTotalPriceAndMargin(enquiryNo).subscribe({
      next: res => {
        if (this.pendingExpandedTotalsEnquiryNo !== enquiryNo) {
          return;
        }

        this.expandedEnquiryTotals = res;
        this.applyExpandedEnquiryTotalsFormatting();
      },
      error: () => {
        if (this.pendingExpandedTotalsEnquiryNo !== enquiryNo) {
          return;
        }

        this.resetExpandedEnquiryTotals();
      }
    }));
  }

  private applyExpandedEnquiryTotalsFormatting(): void {
    if (!this.expandedEnquiryTotals) {
      this.resetExpandedEnquiryTotals();
      return;
    }

    const totalPrice = this.parseNumber(this.expandedEnquiryTotals.totalPrice);
    const totalMargin = this.parseNumber(this.expandedEnquiryTotals.totalMargin);
    const totalMarginPercentage = this.parseNumber(this.expandedEnquiryTotals.totalMarginPercentage);
    if (totalPrice == null || totalMargin == null || totalMarginPercentage == null) {
      this.resetExpandedEnquiryTotals();
      return;
    }

    const priceUom = this.getExpandedTotalsPriceUom();
    const priceSuffix = priceUom ? ` ${priceUom}` : '';
    const formattedPrice = this.formatNumber(totalPrice);
    const formattedMarginPercentage = this.formatNumber(totalMarginPercentage);
    const formattedMarginAmount = this.formatNumber(totalMargin);

    this.expandedEnquiryTotalPriceFormatted = `${formattedPrice}${priceSuffix}`;
    this.expandedEnquiryTotalMarginFormatted = `${formattedMarginPercentage}% / ${formattedMarginAmount}${priceSuffix}`;
    this.expandedEnquiryTotalMarginClass = this.getMarginClass(totalMargin);
  }

  private resetExpandedEnquiryTotals(): void {
    this.expandedEnquiryTotals = null;
    this.expandedEnquiryTotalPriceFormatted = '';
    this.expandedEnquiryTotalMarginFormatted = '';
    this.expandedEnquiryTotalMarginClass = '';
  }

  private getExpandedTotalsPriceUom(): string {
    const fromGrid = this.dataSetItems.find(item => !!item['totalPriceUom'])?.['totalPriceUom'];
    if (fromGrid) {
      return fromGrid;
    }

    const fromItems = this.enquiryItems?.items?.find(item => !!(item as any)['totalPriceUom']) as any;
    return fromItems?.totalPriceUom ?? '';
  }

  private parseNumber(value: string | number | null | undefined): number | null {
    if (value == null || value === '') {
      return null;
    }

    const parsed = typeof value === 'number'
      ? value
      : Number(value.toString().replace(/\s/g, '').replace(',', '.'));

    return Number.isFinite(parsed) ? parsed : null;
  }

  private formatNumber(value: number): string {
    return value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  private getMarginClass(totalMargin: number): string {
    if (totalMargin > 0) return 'green-text';
    if (totalMargin < 0) return 'red-text';
    return '';
  }

  /* EVENTS */
  customIconClick(evt: any) {
    // ToDO - Event custom icon grid clik -- To Remove!!
    // STato == HEADER o OPEN APRO MODALE CONFERMA
    // SE NO APRO DIRETTAMENTE EDIT

    if (evt.indexOf("|") != -1) {
      const { action: _action, row: _obj } = parseGridActionEvent(evt);
      if (_action == 'closeEnquiry') {
        this.selectedEnquiryNo = _obj["EnquiryNo"];
        this.selectedEnquiryStatus = _obj["OfferStatus"];
        this.showCloseEnquiry = true;
      }

      if (_action == 'duplicateEnquiry') {
        // GBR 30/01/2024 - Modifica MQF-86 - Faccio una chiamata alla getEnquiryByNo e apro direttamente la Dialog
        /* this.teiasoftModalService.show('confirm', this.translate.instant("enquiryBook.duplicateEnquiry"), this.translate.instant("enquiryBook.duplicateEnquiryConfirmMessage") + " " + _obj["EnquiryNo"] + "?"
        , _obj["EnquiryNo"], 'confirmDuplicateEnquiry'); */
        this.isDuplicate = true;
        this.getEnquiryByEnquiryNo(_obj["EnquiryNo"]);
      }

      if (_action == 'editEnquiry') {
        this.isDuplicate = false;
        // Check Enquiry Status
        let _status: string = _obj["OfferStatus"].toLowerCase();
        if (_status == 'header' || _status == 'open') {
          // ASK FOR CONFIRMATION
          this.teiasoftModalService.show('confirm', this.translate.instant("enquiryBook.editEnquiry"), this.translate.instant("enquiryBook.editEnquiryConfirmMessage"), _obj["EnquiryNo"], 'confirmEditEnquiry');
        } if (_status == 'edit') {
          this.startEditFlowWithChangeCheck(_obj["EnquiryNo"], false, undefined, false);
        } else {
          //alert("Manage disable icon");
        }
      }

      if (_action == 'changeStatus') {
        this.changeStatusEnquiryNo = _obj["EnquiryNo"];
        this.enquiryOfferStatus = _obj["OfferStatus"];
        this.enquiryMsOfferStatus = _obj["MstOfferStatus"];
        this.showChangeStatus = true;
      }

      if (_action == 'expandRow') {
        this.enquiryItems = new ItemsByEnquiryNo();
        this.dataSetItems = new Array();
        this.expandedEnquiryHeader = {
          enquiryNo: _obj["EnquiryNo"],
          currency: _obj["Currency"] ?? _obj["currency"]
        };
        this.getItemsByEnquiryNo(_obj["EnquiryNo"]);
      }

      if (_action == 'showDocumentTemplate') {
        this.showDocumentTemplateEnquiryNo = _obj["EnquiryNo"];
        this.showDocumentTemplateEnquiryStatus = _obj["OfferStatus"] || "";
        const isEditFlow = (this.showDocumentTemplateEnquiryStatus || '').toLowerCase() == 'edit';
        if (isEditFlow) {
          this.handleOpenQuotationTool();
        } else {
          this.showDocumentTemplateOptions = true;
        }
      }

      if (_action == 'reopenEnquiry') {
        // this.teiasoftModalService.show('confirm', this.translate.instant("enquiryBook.reopenEnquiry"), this.translate.instant("enquiryBook.reopenEnquiryConfirmMessage"), _obj["EnquiryNo"], 'confirmReopenEnquiry');
        this.selectedEnquiryNo = _obj["EnquiryNo"];
        this.showReopenModal = true;
      }

      if (_action == 'downloadQuotation') {
        const enquiryNo = _obj["EnquiryNo"];
        this.teiasoftLoader.start();
        this.subscriptions.add(this.backendService.getQuotationPdf(enquiryNo).subscribe({
          next: (val) => {
            this.downloadQuotationPdf(val, enquiryNo);
          },
          complete: () => {
            this.teiasoftLoader.stop();
          }
        }))
      }

      if (_action == 'openITDCR') {
        this.openIDTCR_EnquiryNo = _obj["EnquiryNo"];
        this.getItemsByEnquiryNo(this.openIDTCR_EnquiryNo);
        this.showOpenIDTCR = true;
      }


    } else {
      if (evt == 'clearDataItems') {
        this.pendingExpandedTotalsEnquiryNo = null;
        this.enquiryItems = new ItemsByEnquiryNo();
        this.dataSetItems = new Array();
        this.expandedEnquiryHeader = undefined;
        this.resetExpandedEnquiryTotals();
      }
    }

  }

  onExpandedGridContextMenuClick(evt: any) {
    const col = evt?.col;
    const row = evt?.row;
    if (!col || !row) return;

    const sourceMap: Record<string, 'F' | 'P' | 'D'> = {
      feasibilityStatus: 'F',
      costsStatus: 'P',
      deliveryStatus: 'D'
    };

    const sourceEvent = sourceMap[col];
    if (!sourceEvent) return;
    if (row[col] !== 'ItdcrInProgress') return;

    const enquiryNo = evt?.parentRow?.EnquiryNo ?? this.expandedEnquiryNo;
    const itemNo = row['itemNo'] ?? row['ItemNo'];
    if (!enquiryNo || itemNo == null) return;

    this.teiasoftLoader.start();
    this.subscriptions.add(
      this.backendService.getInProgressItdcrNumberByItem(enquiryNo, String(itemNo))
        .pipe(finalize(() => this.teiasoftLoader.stop()))
        .subscribe(res => {
          const itdcrNo = res?.itdcrNo;
          if (!itdcrNo) return;
          this.itdcrViewerNo = itdcrNo;
          this.itdcrViewerShowHistory = false;
          this.showItdcrViewerModal = true;
        })
    );
  }


  onOpenItdcrClick($event: OpenItdcrEvent) {
    this.openIDTCR_EnquiryNo = $event.enquiryNo;
    this.openIDTCR_ItemNo = $event.itemNo;
    this.openIDTCR_Source = $event.sourceEvent;
    this.getItemsByEnquiryNo(this.openIDTCR_EnquiryNo);
    this.showOpenIDTCR = true;
  }

  private downloadQuotationPdf(val: any, enquiryNo: string) {
    const base64String = val.quotationPdf;
    const binaryData = window.atob(base64String);
    const arrayBuffer = new Uint8Array(binaryData.length);

    for (let i = 0; i < binaryData.length; i++) {
      arrayBuffer[i] = binaryData.charCodeAt(i);
    }

    const blob = new Blob([arrayBuffer], { type: 'application/pdf' });

    const downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.download = `${enquiryNo}`;

    downloadLink.click();

    window.URL.revokeObjectURL(downloadLink.href);
  }

  closeAndReload(evt: any) {
    this.showChangeStatus = false;
    this.refreshFullGrid();
  }

  onBtnToolbarClick(btn: TTButton) {
    /* ALL ENQUIRIES / MY ENQUIRIES / OFFICE ENQUIRIES */
    if (btn.action!.indexOf('filter') != -1) {
      let _temp: string[] = new Array();
      _temp = btn.action!.split("|");
      /* let _i: number = this.buttonsList.findIndex(x => x.id == btn.id);
      this.buttonsList[_i].state = 'pressed';
      for (var x = 0; x < this.buttonsList.length; x++) {
        if (_i != x) this.buttonsList[x].state = '';
      } */
      this.gridConfiguration.defaultFilterView = _temp[1];
      this.updateEnquiryBookFilterScope();
      this.onUpdateConfiguration(this.gridConfiguration);
      this.refreshFullGrid();
    }

    /* EXPORT EXCEL */
    if (btn.action == 'export') {
      this.exportToExcel = true;
      setTimeout(() => { this.exportToExcel = false }, 250);
    }

    /* ADD ENQUIRY */
    if (btn.action == 'add') {
      this.isDuplicate = false;
      this.customerSpecialRequirements = new Array();
      this.buildAddEnquiryForm('add');
      this.buildDialogButtons();
      this.dialogTitle = this.translate.instant("enquiryBook.add");
      this.dialogIcon = "fal fa-plus";
      this.showAddDialog = true;
      this.getHeaderParametersValues().then(() => {
        // MQF-468
        if (this.gridFilterable == true) {
          this.gridFilterable = false;
          setTimeout(() => this.gridFilterable = true, 250);
        }
        // END
        this.showAddDialog = true;
      });
    }

    /* SHOW SETTINGS GRID */
    if (btn.action == 'showSettingsGrid') {
      this.showSettingsDialog = true;
    }

    /* SHOW FILTER */
    if (btn.action == 'showFilter') {
      this.gridFilterable = true;
      this.buildButtonsList();
    }

    /* CLOSE FILTER */
    if (btn.action == 'closeFilter') {
      this.gridFilterable = false;
      this.buildButtonsList();
    }

    /* CLEAR FILTER */
    if (btn.action == 'clearFilter') {
      this.clearFilters = true;
      setTimeout(() => { this.clearFilters = false }, 250);
      this.refreshFullGrid();
    }

  }

  onDialogButtonClick(evt: DialogObject) {
    if (evt.action == 'cancel') {
      this.showAddDialog = false;
    }

    // Valido sia per CreateEnquiry che per CreateEnquiry e AddItems 
    if (evt.action == 'save' || evt.action == 'save-add-items' || evt.action == 'save-add-items-AI') {
      //if (!this.checkWtOdId(true)) return;
      let _enquiry: CreateEnquiry = new CreateEnquiry();
      //_enquiry.salesOfficeId = this.headerParametersValues.salesOffices!.filter(x => x.officeCode == this.globals.userLogged!.office!)[0].officeId;
      _enquiry.salesPersonId = evt.dialogForm!.find(x => x.field == 'salesPerson')!.value;
      _enquiry.salesOfficeId = evt.dialogForm!.find(x => x.field == 'salesOfficeId')!.value;
      _enquiry.customerId = evt.dialogForm!.find(x => x.field == 'customerId')!.value!;
      // CHECK IF I HAVE A DUMMY CUSTOMER
      _enquiry.customer = new CreateEnquiryCustomer();
      if (this.dummyCustomer && this.dummyCustomer.customerCountryId) {
        _enquiry.customer!.customerCountryId = this.dummyCustomer.customerCountryId;
        _enquiry.customer!.customerName = this.dummyCustomer.customerName!;
        _enquiry.customer!.unitSystem = this.dummyCustomer.unitSystem!;
      } else {
        _enquiry.customer!.customerCountryId = evt.dialogForm!.find(x => x.field == 'customerCountry')!.value!;
        _enquiry.customer!.customerName = evt.dialogForm!.find(x => x.field == 'customerName')!.text!;
        _enquiry.customer!.unitSystem = evt.dialogForm!.find(x => x.field == 'unitSystem')!.value!;
        _enquiry.customerId = evt.dialogForm!.find(x => x.field == 'customerId')!.value!;
      }
      _enquiry.customerEnquiryNo = evt.dialogForm!.find(x => x.field == 'customerEnquiryNo')!.value!;
      _enquiry.unitSystem = evt.dialogForm!.find(x => x.field == 'unitSystem')!.value!;
      _enquiry.currency = evt.dialogForm!.find(x => x.field == 'currency')!.value!;
      let _date: number = Number(evt.dialogForm!.find(x => x.field == 'dueDate')!.value!);
      // let _dateOption: number = new Date(evt.dialogForm!.find(x => x.field == 'optionDate')!.value!).getTime();

      _enquiry.dueDate = _date == 0 ? null : _date;
      // _enquiry.optionDate = _dateOption;
      _enquiry.projectName = evt.dialogForm!.find(x => x.field == 'projectName')!.value!;
      _enquiry.alloySurcharge = true;
      _enquiry.orderReason = evt.dialogForm!.find(x => x.field == 'orderReason')!.value!;
      _enquiry.applicableNorms = evt.dialogForm!.find(x => x.field == 'applicableNorms')!.value!;
      _enquiry.normGradesId = new Array();
      let _ids: string[] = evt.dialogForm!.find(x => x.field == 'normGrades')!.value!.toString().split(",");
      for (var x = 0; x < _ids.length; x++) {
        if (_ids[x] != '')
          _enquiry.normGradesId.push(parseInt(_ids[x]));
      }
      if (_enquiry.normGradesId.length == 0) _enquiry.normGradesId = null;
      _enquiry.marketingGradeId = null;
      _enquiry.rawMaterialGrade = evt.dialogForm!.find(x => x.field == 'rawMaterialGrades')!.text! != '' ? evt.dialogForm!.find(x => x.field == 'rawMaterialGrades')!.text! : null;
      _enquiry.testCategory = evt.dialogForm!.find(x => x.field == 'testCategory')!.value!;
      let _digits: number = 2;
      if (_enquiry.unitSystem == 'Metric')
        _digits = this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'od')[0] ? this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'od')[0].metricDigits! : 2;
      else
        _digits = this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'od')[0] ? this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'od')[0].imperialDigits! : 2;

      _enquiry.od = parseFloat(parseFloat(evt.dialogForm!.find(x => x.field == 'od')!.value!).toFixed(_digits)!);

      let _odUom: string = evt.dialogForm!.find(x => x.field == 'odUom')!.value!;
      _enquiry.odUom = _odUom != '' ? _odUom : null;

      if (_enquiry.unitSystem == 'Metric')
        _digits = this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'wt')[0] ? this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'wt')[0].metricDigits! : 2;
      else
        _digits = this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'wt')[0] ? this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'wt')[0].imperialDigits! : 2;

      _enquiry.wt = parseFloat(parseFloat(evt.dialogForm!.find(x => x.field == 'wt')!.value!).toFixed(_digits));

      let _wtUom: string = evt.dialogForm!.find(x => x.field == 'wtUom')!.value!;
      _enquiry.wtUom = _wtUom != '' ? _wtUom : null;


      if (_enquiry.unitSystem == 'Metric')
        _digits = this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'id')[0] ? this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'id')[0].metricDigits! : 2;
      else
        _digits = this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'id')[0] ? this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'id')[0].imperialDigits! : 2;

      _enquiry.id = parseFloat(parseFloat(evt.dialogForm!.find(x => x.field == 'id')!.value!).toFixed(_digits));

      let _idUom: string = evt.dialogForm!.find(x => x.field == 'idUom')!.value!;
      _enquiry.idUom = _idUom != '' ? _idUom : null;
      _enquiry.npsScheduleId = evt.dialogForm!.find(x => x.field == 'npsDescription')!.value! != '' ? parseInt(evt.dialogForm!.find(x => x.field == 'npsDescription')!.value!) : null;
      _enquiry.smsId = evt.dialogForm!.find(x => x.field == 'sms')!.value!;

      if (_enquiry.unitSystem == 'Metric')
        _digits = this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'totalweight')[0] ? this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'totalweight')[0].metricDigits! : 2;
      else
        _digits = this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'totalweight')[0] ? this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'totalweight')[0].imperialDigits! : 2;

      _enquiry.totalWeight = parseFloat(parseFloat(evt.dialogForm!.find(x => x.field == 'totalWeight')!.value!).toFixed(_digits));

      _enquiry.totalWeightUom = evt.dialogForm!.find(x => x.field == 'totalWeightUom')!.value!;
      _enquiry.remark = evt.dialogForm!.find(x => x.field == 'remark')!.value!;
      _enquiry.marketFamilyId = parseInt(evt.dialogForm!.find(x => x.field == 'marketFamily')!.value!);

      // CUSTOMER REQUEST DATE
      _date = Number(evt.dialogForm!.find(x => x.field == 'customerRequestDate')!.value!);
      _enquiry.customerRequestDate = _date == 0 ? null : _date;

      _enquiry.creationMode = "";
      if (!this.isDuplicate && evt.action == 'save')
        _enquiry.creationMode = "Create";

      if (!this.isDuplicate && (evt.action == 'save-add-items' || evt.action == 'save-add-items-AI'))
        _enquiry.creationMode = "CreateAndEdit";

      if (this.isDuplicate && (evt.action == 'save' || evt.action == 'save-add-items' || evt.action == 'save-add-items-AI'))
        _enquiry.creationMode = "Duplicate";

      _enquiry.sourceEnquiryNo = _enquiry.creationMode == 'Duplicate' ? this.sourceEnquiryNo : null;
      _enquiry.mstOfferStatus = evt.dialogForm!.find(x => x.field == 'mstOfferStatus')!.value!;

      if (_enquiry.unitSystem == 'Metric')
        _digits = this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'length')[0] ? this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'length')[0].metricDigits! : 2;
      else
        _digits = this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'length')[0] ? this.roundDigitsForEnquiryForm.filter(x => x.fieldName?.toLowerCase() == 'length')[0].imperialDigits! : 2;

      // _enquiry.length = parseFloat(parseFloat(evt.dialogForm!.find(x => x.field == 'length')!.value!).toFixed(_digits));

      // _enquiry.lengthUom = evt.dialogForm!.find(x => x.field == 'lengthUom')!.value!;

      _enquiry.offerValidityId = evt.dialogForm!.find(x => x.field == 'offerValidityId')!.value!;
      let _offerValidityOption: number = Number(evt.dialogForm!.find(x => x.field == 'offerValidityDate')!.value!);
      _enquiry.offerValidityDate = Number.isFinite(_offerValidityOption) && _offerValidityOption > 0 ? _offerValidityOption : null;
      const offerSchemeCode = evt.dialogForm!.find(x => x.field == 'offerSchemeCode')?.value;
      const bonusSchemeCode = evt.dialogForm!.find(x => x.field == 'bonusSchemeCode')?.value;
      _enquiry.offerSchemeCode = offerSchemeCode != null && offerSchemeCode !== '' ? offerSchemeCode : null;
      _enquiry.bonusSchemeCode = bonusSchemeCode != null && bonusSchemeCode !== '' ? bonusSchemeCode : null;

      // customer special requirement
      _enquiry.customerSpecialRequirements = this.customerSpecialRequirements;

      let _customerRequestDate: number = Number(evt.dialogForm!.find(x => x.field == 'customerRequestDate')!.value!);
      _enquiry.customerRequestDate = Number.isFinite(_customerRequestDate) && _customerRequestDate > 0 ? _customerRequestDate : null;

      if (this.isDuplicate) {
        this.checkItdcrResultsBeforeDuplicateCreation(_enquiry, evt.action!, evt.attachmentsToUpdate!);
      } else {
        this.checkForSimilarEnquiriesAndCreateEnquiry(_enquiry, evt.action!, evt.attachmentsToUpdate!);
      }
    }

    if (evt.action == 'specialRequirements') {
      this.specialRequirementsReadOnly = false;
      this.showSpecialRequirements = true;
    }
  }

  onReturnToEnquiryBook(evt: any) {
    // DELETE OBJECT
    this.enquiryForm = new Array();
    this.enquiryToEdit = new Enquiry();
    this.openEditPricesTrigger = 0;

    this.showEditEnquiry = false
    this.refreshFullGrid();

    // MQF-1162: reload items and totals of the expanded row, otherwise it keeps showing pre-edit values
    const expandedEnquiryNo = this.expandedEnquiryHeader?.enquiryNo;
    if (expandedEnquiryNo) {
      this.getItemsByEnquiryNo(expandedEnquiryNo);
    }
  }

  onUpdateConfiguration(gridConfiguration: GridConfiguration) {
    this.utils.upsertGridConfiguration(gridConfiguration);
    this.gridConfiguration = { ...gridConfiguration }; // sync current gridConfiguration

    this.updateUserConfiguration();
  }

  onCreateEditDummyCustomer(customer: CreateEnquiryCustomer) {
    this.dummyCustomer = new CreateEnquiryCustomer();
    this.dummyCustomer = customer;

    /* MODIFY DIALOG FORM FOR UPDATING */
    let _i: number = this.enquiryForm.findIndex(x => x.field == 'customerName');
    this.enquiryForm[_i].value = this.dummyCustomer.customerName;
    this.enquiryForm[_i].text = this.dummyCustomer.customerName;

    _i = this.enquiryForm.findIndex(x => x.field == 'customerId');
    this.enquiryForm[_i].value = null;
    this.enquiryForm[_i].text = null;

    _i = this.enquiryForm.findIndex(x => x.field == 'customerCountry');
    this.enquiryForm[_i].value = this.dummyCustomer.customerCountryId;
    this.enquiryForm[_i].text = this.headerParametersValues.countries?.filter(x => x.countryId == this.dummyCustomer.customerCountryId)[0].countryName;

    _i = this.enquiryForm.findIndex(x => x.field == 'unitSystem');
    this.enquiryForm[_i].value = this.dummyCustomer.unitSystem;
    this.enquiryForm[_i].text = this.translate.instant("enquiryBook." + this.dummyCustomer.unitSystem);

    this.setCurrencyFormValue(this.dummyCustomer.currency ?? this.getDefaultCurrencyForCountry(this.dummyCustomer.customerCountryId));

    _i = this.enquiryForm.findIndex(x => x.field == 'customerCode');
    this.enquiryForm[_i].disabled = true;
    this.enquiryForm[_i].isRequired = false;
    this.enquiryForm[_i].value = '';
    this.enquiryForm[_i].text = '';

    this.setSelectUoms();
    this.showCreateEditDummy = false;
  }

  onFormButtonClick(evt: any) {
    let _action: string = "";
    if (evt["action"]) _action = evt["action"];
    if (_action == 'select|customer') {
      this.getCustomers();
    }

    if (_action.endsWith("dummy")) {
      if (_action.startsWith("create"))
        this.isCreateDummy = true;

      if (_action.startsWith("edit"))
        this.isCreateDummy = false;

      if (_action.startsWith("delete")) {
        this.isCreateDummy = false;
        /* CLEAR DUMMY CUSTOMER */
        let _i: number = this.enquiryForm.findIndex(x => x.field == 'customerName');
        this.enquiryForm[_i].value = '';
        this.enquiryForm[_i].text = '';

        _i = this.enquiryForm.findIndex(x => x.field == 'customerCountry');
        this.enquiryForm[_i].value = '';
        this.enquiryForm[_i].text = '';

        _i = this.enquiryForm.findIndex(x => x.field == 'unitSystem');
        this.enquiryForm[_i].value = '';
        this.enquiryForm[_i].text = '';

        this.setCurrencyFormValue('');

        _i = this.enquiryForm.findIndex(x => x.field == 'customerCode');
        this.enquiryForm[_i].value = '';
        this.enquiryForm[_i].text = '';

        this.setSelectUoms();
        this.checkTTButtonsCustomer('clearCustomer');
        return;
      }


      this.showCreateEditDummy = true;
    }

    if (_action.endsWith("nps") || _action.endsWith("wtOdIt")) {
      let _temp: string[] = new Array();
      _temp = _action.split("|");
      this.setWtOdIdNps(_temp[1]);
    }
  }

  checkTTButtonsCustomer(action: string) {
    let _i: number = this.enquiryForm.findIndex(x => x.field == 'toolbarCustomer');
    for (var x = 0; x < this.enquiryForm[_i].toolbarButtonsList!.length; x++) {
      if (action == 'savedCustomer' || action == 'savedDummy') {
        this.enquiryForm[_i].toolbarButtonsList![0].disabled = action == 'savedCustomer' ? false : true;
        this.enquiryForm[_i].toolbarButtonsList![1].disabled = true;
        this.enquiryForm[_i].toolbarButtonsList![2].disabled = action == 'savedCustomer' ? true : false;
        this.enquiryForm[_i].toolbarButtonsList![3].disabled = false;
      }

      if (action == 'clearCustomer') {
        this.enquiryForm[_i].toolbarButtonsList![0].disabled = false;
        this.enquiryForm[_i].toolbarButtonsList![1].disabled = false;
        this.enquiryForm[_i].toolbarButtonsList![2].disabled = true;
        this.enquiryForm[_i].toolbarButtonsList![3].disabled = true;
      }
    }
  }

  isCustomerChangeValid(newCustomerUnitSystem: string, newCurrency?: string): boolean {
    const currentUnitSystem = this.enquiryForm.find(form => form.field === "unitSystem")?.value;
    const currentCurrency = this.enquiryForm.find(form => form.field === "currency")?.value;

    if (this.sourceEnquiryNo && currentUnitSystem != newCustomerUnitSystem)
      return false; // the enquiry is a duplicated and changing customer will affect the unit system => this is not a valid operation

    if (this.sourceEnquiryNo && currentCurrency != newCurrency)
      return false;

    return true;
  }

  onFormAutocompleteChanged(evt: Autocomplete) {
    // Prendi i dati dalla addEnquiryForm e modificali con i dati presenti nella evt
    if (evt.field == 'customer') {
      let _customerId: number | null = null;
      let _customerName: string = "";
      let _countryId: number | null = null;
      let _countryName: string = "";
      let _customerCode: string = "";
      let _unitSystem: string = "";
      let _currency: string = "";


      if (evt.object! != '') {
        let _data: any = JSON.parse(evt.object!);
        _customerId = _data["customerId"];
        _customerName = _data["customerName"];
        _countryId = _data["customerCountry"]["countryId"];
        _countryName = _data["customerCountry"]["countryName"];
        _customerCode = _data["customerCode"];
        _unitSystem = _data["unitSystem"];
        _currency = this.getDefaultCurrencyForCountry(_countryId);
      }

      if (!this.isCustomerChangeValid(_unitSystem, _currency) && this.isDuplicate) {
        this.teiasoftToaster.show('error', this.translate.instant('errors.customerUnitSystemIncompatible'));
        return;
      }

      let _i: number = this.enquiryForm.findIndex(x => x.field == 'customerName');
      this.enquiryForm[_i].value = _customerId; // _data["customerId"];
      this.enquiryForm[_i].text = _customerName; // _data["customerName"];
      this.enquiryForm[_i].isValid = true;

      _i = this.enquiryForm.findIndex(x => x.field == 'customerCountry');
      this.enquiryForm[_i].value = _countryId;// _data["customerCountry"]["countryId"];
      this.enquiryForm[_i].text = _countryName; // _data["customerCountry"]["countryName"];

      _i = this.enquiryForm.findIndex(x => x.field == 'customerCode');
      this.enquiryForm[_i].isRequired = true;
      this.enquiryForm[_i].value = _customerCode; // _data["customerCode"];
      this.enquiryForm[_i].text = _customerCode; //_data["customerCode"];

      _i = this.enquiryForm.findIndex(x => x.field == 'unitSystem');
      this.enquiryForm[_i].value = _unitSystem; //_data["unitSystem"];
      this.enquiryForm[_i].text = _unitSystem; //_data["unitSystem"];

      this.setCurrencyFormValue(_currency);

      _i = this.enquiryForm.findIndex(x => x.field == 'customerId');
      this.enquiryForm[_i].value = _customerId; // _data["customerId"];
      this.enquiryForm[_i].text = _customerId; //_data["customerId"];

      this.showSelectCustomer = false;
      //this.checkTTButtonsCustomer('savedCustomer');
      this.setSelectUoms();
      this.setRoundDigitsEnquiryForm();
    }

    /*     if (evt.field == 'marketingGrades'){
          let _data: any = JSON.parse(evt.object!);
          let _i: number = this.enquiryForm.findIndex(x => x.field == 'marketingGrades');
          this.enquiryForm[_i].value =  _data["marketingGradeId"];
          this.enquiryForm[_i].text = _data["marketingGradeCode"];
    
          this.getRawMaterialGrades();
        } */

    if (evt.field == 'rawMaterialGrades') {
      let _rawMaterialGradeId: number | null = null;
      let _rawMaterialGradeCode: string = "";

      if (evt.object! != '') {
        let _data: any = JSON.parse(evt.object!);
        _rawMaterialGradeId = _data["rawMaterialGradeId"];
        _rawMaterialGradeCode = _data["rawMaterialGradeCode"];
      }

      let _i: number = this.enquiryForm.findIndex(x => x.field == 'rawMaterialGrades');
      this.enquiryForm[_i].value = _rawMaterialGradeId; // _data["rawMaterialGradeId"];
      this.enquiryForm[_i].text = _rawMaterialGradeCode; //_data["rawMaterialGradeCode"];
      this.enquiryForm[_i].isValid = true;
    }

    if (evt.field == 'sms') {
      let _data: any = JSON.parse(evt.object!);
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'sms');
      this.enquiryForm[_i].value = _data["smsId"];
      this.enquiryForm[_i].text = _data["name"];
    }

  }

  setRoundDigitsEnquiryForm() {
    // ROUND DIGITS
    if (!this.roundDigitsForEnquiryForm || this.roundDigitsForEnquiryForm.length == 0) return;
    if (!this.enquiryForm || this.enquiryForm.length == 0) return;

    let _iUS: number = this.enquiryForm.findIndex(x => x.field == "unitSystem");
    let _unitSystem: string = this.enquiryForm[_iUS].value!;

    let _i: number = -1;
    for (var k = 0; k < this.roundDigitsForEnquiryForm.length; k++) {
      _i = this.enquiryForm.findIndex(x => x.field?.toLowerCase() == this.roundDigitsForEnquiryForm[k].fieldName!);
      if (_i != -1) {
        if (_unitSystem == 'Metric' && this.enquiryForm[_i].value != null && this.enquiryForm[_i].value != '') {
          this.enquiryForm[_i].value = parseFloat(this.enquiryForm[_i].value).toFixed(this.roundDigitsForEnquiryForm[k].metricDigits!);
          //this.dialogForm[_i].roundDigits = this.roundDigitsForEnquiryForm[k].metricDigits!
        }

        if (_unitSystem == 'Imperial' && this.enquiryForm[_i].value != null && this.enquiryForm[_i].value != '') {
          this.enquiryForm[_i].value = parseFloat(this.enquiryForm[_i].value).toFixed(this.roundDigitsForEnquiryForm[k].imperialDigits!);
          //this.dialogForm[_i].roundDigits = this.roundDigitsForEnquiryForm[k].imperialDigits!;
        }

        if (_unitSystem == 'Metric') {
          this.enquiryForm[_i].roundDigits = this.roundDigitsForEnquiryForm[k].metricDigits!
        }

        if (_unitSystem == 'Imperial') {
          this.enquiryForm[_i].roundDigits = this.roundDigitsForEnquiryForm[k].imperialDigits!;
        }
      }
    }

  }

  onFormAutocompleteChangedRows(evt: Autocomplete) {
    if (evt.field == 'normGrades') {
      let _data: any[] = JSON.parse(evt.object!);
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'normGrades');
      let _ids: number[] = new Array();
      let _codes: string[] = new Array();
      for (var x = 0; x < _data.length; x++) {
        _ids.push(_data[x]["normGradeId"]);
        _codes.push(_data[x]["normGradeCode"]);
      }
      this.enquiryForm[_i].value = _ids;
      this.enquiryForm[_i].text = _codes;
      this.enquiryForm[_i].isValid = true;

      // Se ho selezionato qualcosa abilito le RawMaterialGrade
      if (_ids.length > 0) {
        this.getRawMaterialGrades('', _ids);
      }
    }
  }

  onFormAutocompleteInputChange(evt: Autocomplete) {
    if (evt.field == 'customer') {
      let _i: number = this.enquiryForm.findIndex(x => x.field!.toLowerCase() === 'customername');
      this.enquiryForm[_i].autoCompleteDataset = new Array();
      if (evt.object!.length > 0) {
        this.enquiryForm[_i].autoCompleteDataset = [
          // Customers whose name or code starts with the value
          ...this.headerParametersValues.customers!.filter(x =>
            x.customerName!.toLowerCase().startsWith(evt.object!.toLowerCase()) ||
            x.customerCode!.startsWith(evt.object!)
          ).sort((a, b) => a.customerName!.localeCompare(b.customerName!)),

          // Customers whose name or code contains the value but don't start with it
          ...this.headerParametersValues.customers!.filter(x =>
            (x.customerName!.toLowerCase().includes(evt.object!.toLowerCase()) &&
              !x.customerName!.toLowerCase().startsWith(evt.object!.toLowerCase())) ||
            (x.customerCode!.includes(evt.object!) &&
              !x.customerCode!.startsWith(evt.object!))
          ).sort((a, b) => a.customerName!.localeCompare(b.customerName!))
        ];
      } else {
        this.enquiryForm[_i].autoCompleteDataset = this.getFirst100Data('customers', 'customerName');

        // Se sono in edit e il customer non è presente nei 100 la aggiungo
        if (this.enquiryToEdit && this.enquiryToEdit.header && this.enquiryToEdit.header.customer!) {
          if (this.enquiryForm[_i].autoCompleteDataset!.findIndex(x => x.customer.customerId == this.enquiryToEdit.header!.customer?.customerId) == -1)
            this.enquiryForm[_i].autoCompleteDataset!.unshift(this.enquiryToEdit.header.customer);
        }

      }
      if (this.enquiryForm[_i].autoCompleteDataset == undefined || this.enquiryForm[_i].autoCompleteDataset!.length == 0) {
        _i = this.enquiryForm.findIndex(x => x.field == 'customerName');
        this.enquiryForm[_i].value = null;
        this.enquiryForm[_i].text = "";
      }
    }

    if (evt.field == 'normGrades') {
      this.getNormGrades(evt.object!);
    }

    if (evt.field == 'rawMaterialGrades') {
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'normGrades');
      this.getRawMaterialGrades(evt.object!, this.enquiryForm[_i].value!);
    }

    /* if (evt.field == 'sms'){
      let _i: number = this.enquiryForm.findIndex(x => x.field!.toLowerCase() === 'sms');
      this.enquiryForm[_i].autoCompleteDataset = new Array();
      this.enquiryForm[_i].autoCompleteDataset = this.headerParametersValues.sms!.filter(x => x.name!.toLowerCase().includes(evt.object!.toLowerCase()));
    } */

    // GBR 23/01/2024 - RULE FOR WT/ID/OD
    if (evt.field == 'id' || evt.field == 'od' || evt.field == 'wt') {
      this.checkWtOdId();
    }
  }

  checkWtOdId() {
    let _iOd: number = this.enquiryForm.findIndex(x => x.field!.toLowerCase() === 'od');
    let _odValue: any = this.enquiryForm[_iOd].value ? this.enquiryForm[_iOd].value : '';

    let _iId: number = this.enquiryForm.findIndex(x => x.field!.toLowerCase() === 'id');
    let _idValue: any = this.enquiryForm[_iId].value ? this.enquiryForm[_iId].value : '';

    let _iWt: number = this.enquiryForm.findIndex(x => x.field!.toLowerCase() === 'wt');
    let _wtValue: any = this.enquiryForm[_iWt].value ? this.enquiryForm[_iWt].value : '';

    if (_odValue != '' && _idValue == '' && _wtValue == '') {
      this.enquiryForm[_iOd].isRequired = true;
      this.enquiryForm[_iOd].isValid = true;
      this.enquiryForm[_iId].isRequired = true;
      this.enquiryForm[_iId].isValid = false;
      this.enquiryForm[_iWt].isRequired = true;
      this.enquiryForm[_iWt].isValid = false;
    }

    if (_odValue == '' && _idValue != '' && _wtValue == '') {
      this.enquiryForm[_iOd].isRequired = true;
      this.enquiryForm[_iOd].isValid = false;
      this.enquiryForm[_iId].isRequired = true;
      this.enquiryForm[_iId].isValid = true;
      this.enquiryForm[_iWt].isRequired = true;
      this.enquiryForm[_iWt].isValid = false;
    }

    if (_odValue == '' && _idValue == '' && _wtValue != '') {
      this.enquiryForm[_iOd].isRequired = true;
      this.enquiryForm[_iOd].isValid = false;
      this.enquiryForm[_iId].isRequired = true;
      this.enquiryForm[_iId].isValid = false;
      this.enquiryForm[_iWt].isRequired = true;
      this.enquiryForm[_iWt].isValid = true;
    }

    if (_odValue != '' && _idValue != '' && _wtValue == '') {
      this.enquiryForm[_iOd].isRequired = true;
      this.enquiryForm[_iOd].isValid = true;
      this.enquiryForm[_iId].isRequired = true;
      this.enquiryForm[_iId].isValid = true;
      this.enquiryForm[_iWt].isRequired = false;
      this.enquiryForm[_iWt].isValid = true;
    }

    if (_odValue == '' && _idValue != '' && _wtValue != '') {
      this.enquiryForm[_iOd].isRequired = false;
      this.enquiryForm[_iOd].isValid = true;

      this.enquiryForm[_iId].isRequired = true;
      this.enquiryForm[_iId].isValid = true;
      this.enquiryForm[_iWt].isRequired = true;
      this.enquiryForm[_iWt].isValid = true;
    }

    if (_odValue != '' && _idValue == '' && _wtValue != '') {
      this.enquiryForm[_iOd].isRequired = true;
      this.enquiryForm[_iOd].isValid = true;

      this.enquiryForm[_iId].isRequired = false;
      this.enquiryForm[_iId].isValid = true;

      this.enquiryForm[_iWt].isRequired = true;
      this.enquiryForm[_iWt].isValid = true;

    }

    // check all uoms have a value
    const iOdUom = this.enquiryForm.findIndex(x => x.field === 'odUom');
    const iIdUom = this.enquiryForm.findIndex(x => x.field === 'idUom');
    const iWtUom = this.enquiryForm.findIndex(x => x.field === 'wtUom');

    const vOd = iOdUom > -1 ? (this.enquiryForm[iOdUom].value || '') : '';
    const vId = iIdUom > -1 ? (this.enquiryForm[iIdUom].value || '') : '';
    const vWt = iWtUom > -1 ? (this.enquiryForm[iWtUom].value || '') : '';

    const sourceVal = vOd || vId || vWt;
    if (!sourceVal) {
      // nothing to copy from
      return;
    }

    const setIfEmpty = (idx: number) => {
      if (idx < 0) return;
      const fld = this.enquiryForm[idx];
      if (!fld.value) {
        fld.value = sourceVal;
        if (fld.optionsList && fld.optionsList.length) {
          const opt = fld.optionsList.find((o: any) => o.value === sourceVal);
          if (opt) fld.text = opt.text;
        }
      }
    };

    setIfEmpty(iOdUom);
    setIfEmpty(iIdUom);
    setIfEmpty(iWtUom);

  }

  onFormSelectChanged(evt: DialogSelect) {
    // First Run
    if (!evt.option) return;

    if (evt.field == 'salesPerson') {
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'salesPerson');
      this.enquiryForm[_i].value = evt.option.value!;
      this.enquiryForm[_i].text = evt.option.text!;
      let _iO: number = this.enquiryForm.findIndex(x => x.field == 'salesOfficeId');
      let _offices: SalesOfficePerson[] = new Array();
      _offices = this.headerParametersValues.salesPersons!.filter(x => x.userId == evt.option!.value!)[0].salesOffices!;
      let _list: SelectOption[] = new Array();
      for (var x = 0; x < _offices!.length; x++) {
        let _item: SelectOption = new SelectOption();
        _item.value = _offices[x].officeId;
        _item.text = this.headerParametersValues.salesOffices!.filter(o => o.officeId == _offices[x].officeId)[0].officeCode!;
        _list.push(_item);
      }
      this.enquiryForm[_iO].optionsList = new Array();
      this.enquiryForm[_iO].optionsList = _list;
      this.enquiryForm[_iO].value = _offices.filter(o => o.isDefault! == true)[0].officeId
      this.enquiryForm[_iO].text = this.headerParametersValues.salesOffices!.filter(x => x.officeId == this.enquiryForm[_iO].value)[0].officeCode!;
    }

    if (evt.field == 'salesOfficeId') {
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'salesOfficeId');
      this.enquiryForm[_i].value = evt.option.value!;
      this.enquiryForm[_i].text = evt.option.text!;
    }

    // ORDER REASON CHANGED
    if (evt.field == 'orderReason') {
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'orderReason');
      this.enquiryForm[_i].value = evt.option.value!;
      this.enquiryForm[_i].text = evt.option.text!;
      // MQF 169 - Prefill di MarketFamily sulla base dell'order reason selezionato
      if (this.isDuplicate == false) { // MQF-381
        let _iMf: number = this.enquiryForm.findIndex(x => x.field == 'marketFamily');
        let _mf: MarketFamily = new MarketFamily();
        if (evt.option.value! == 'Project')
          _mf = this.headerParametersValues.marketFamily!.filter(x => x.isDefaultForProject == true)[0];
        else
          _mf = this.headerParametersValues.marketFamily!.filter(x => x.isDefaultForStock == true)[0];

        if (_mf) {
          this.enquiryForm[_iMf].value = _mf.marketFamilyId;
          this.enquiryForm[_iMf].text = _mf.name;
        } else {
          this.enquiryForm[_iMf].value = '';
          this.enquiryForm[_iMf].text = '';
        }
      }

    }

    // UNIT SYSTEM CHANGED
    if (evt.field == 'unitSystem') {
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'unitSystem');
      if (this.enquiryForm[_i].value != evt.option!.value) {
        this.enquiryForm[_i].value = evt.option!.value;
        this.enquiryForm[_i].text = evt.option!.text;
        this.setSelectUoms();
      }
    }

    if (evt.field == 'currency') {
      this.setCurrencyFormValue(evt.option!.value?.toString() ?? '');
    }

    if (evt.field == 'alloySurcharge') {
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'alloySurcharge');
      //if (this.enquiryForm[_i].value != evt.option!.value){
      this.enquiryForm[_i].value = evt.option!.value;
      this.enquiryForm[_i].text = evt.option!.text;
      //}
    }

    if (evt.field == 'mstOfferStatus') {
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'mstOfferStatus');
      if (this.enquiryForm[_i].value != evt.option!.value) {
        this.enquiryForm[_i].value = evt.option!.value;
        this.enquiryForm[_i].text = evt.option!.text;
      }
    }

    if (evt.field == 'odUom' || evt.field == 'idUom' || evt.field == 'wtUom') {
      //this.checkWtOdId(false);
    }

    if (evt.field == 'totalWeightUom') {
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'totalWeight');
      if (this.enquiryForm[_i].disabled) {
        this.teiasoftToaster.show("info", this.translate.instant("enquiryBook.totalWeightUpdate"));
      }
    }

    if (evt.field == 'smsMarketingRoute') {
      let _iO: number = this.enquiryForm.findIndex(x => x.field == 'sms');

      this.enquiryForm[_iO].optionsList = new Array();
      this.enquiryForm[_iO].optionsList = this.getSms(evt.option.value);

      if (this.enquiryForm[_iO].optionsList?.map(o => o.text).includes(this.enquiryForm[_iO].text)) {
        this.enquiryForm[_iO].value = this.enquiryForm[_iO].optionsList?.find(o => o.text == this.enquiryForm[_iO].text)?.value;
      }
      else {
        this.enquiryForm[_iO].value = '';
        this.enquiryForm[_iO].text = '';
      }
    }

    // offer validity CHANGED
    if (evt.field == 'offerValidityId') {
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'offerValidityId');
      let _iDate: number = this.enquiryForm.findIndex(x => x.field == 'offerValidityDate');
      this.enquiryForm[_i].value = evt.option!.value;

      // if this option is custom show  offerValidityDate
      const isCustomOfferValidity = this.headerParametersValues.offerValidities!.filter(ov => ov.isCustom && ov.id == this.enquiryForm[_i].value).length > 0;

      this.enquiryForm[_iDate].visible = isCustomOfferValidity;
      this.enquiryForm[_iDate].isRequired = isCustomOfferValidity;

      if (!isCustomOfferValidity) {
        this.enquiryForm[_iDate].value = null;
        this.enquiryForm[_iDate].text = null;
      }
    }
  }

  onFormAutocompletLinkClicked(evt: string) {
    let _obj: any = { action: evt };
    this.onFormButtonClick(_obj);
  }

  onFormAutocompleteRemoveElement(evt: any) {
    /* let _i: number = this.enquiryForm.findIndex(x => x.field! == 'normGrades');
    let _valueIndex: number = this.enquiryForm[_i].text!.findIndex((x: any) => x == evt["object"]);
    this.enquiryForm[_i].text!.splice(_valueIndex,1);
    this.enquiryForm[_i].value!.splice(_valueIndex,1);*/

    let _i: number = this.enquiryForm.findIndex(x => x.field!.toLowerCase() === 'normgrades');
    // REMOVE TEXT
    let _texts: string[] = this.enquiryForm[_i].text.toString().split(',');
    let _x: number = _texts.findIndex(x => x == evt.object);
    this.enquiryForm[_i].text = _texts.filter(x => x != evt.object); //.join(',');

    // REMOVE VALUE
    let _values: any[] = this.enquiryForm[_i].value.toString().split(',');
    let _valToRemove = this.enquiryForm[_i].value.toString().split(',')[_x];
    this.enquiryForm[_i].value = _values.filter(x => x != _valToRemove); //.join(',');

    // CLEAR RAW MATERIAL GRADES
    let _ids: number[] = new Array();
    if (this.enquiryForm![_i].value! != '') {
      for (var x = 0; x < this.enquiryForm![_i].value!.toString().split(',').length; x++) {
        _ids.push(parseInt(this.enquiryForm![_i].value!.toString().split(',')[x]));
      }
    }

    if (this.enquiryForm[_i].value!.length > 0) {
      this.getRawMaterialGrades('', _ids); // MQF-152
    } else {
      _i = this.enquiryForm.findIndex(x => x.field! == 'rawMaterialGrades');
      this.enquiryForm[_i].value = null;
      this.enquiryForm[_i].text = null;
      this.enquiryForm[_i].autoCompleteDataset = new Array();
      this.enquiryForm[_i].disabled = true;
      // MQF-401
      this.enquiryForm[_i].isRequired = false;
    }
  }

  setWtOdIdNps(show: string) {
    if (show == 'nps') {

      let _i: number;
      // Turn ON
      _i = this.enquiryForm.findIndex(x => x.field == 'npsDescription');
      this.enquiryForm[_i].disabled = false;
      this.enquiryForm[_i].isRequired = true;
      this.enquiryForm[_i].value = '';
      this.enquiryForm[_i].text = '';

      this.getNpsAndSchedules(true); // MQF-381
    } else {
      // Turn ON 
      let _i: number = this.enquiryForm.findIndex(x => x.field == 'od');
      //this.enquiryForm[_i].disabled = false;
      this.enquiryForm[_i].isRequired = true;
      this.enquiryForm[_i].value = '';
      this.enquiryForm[_i].text = '';
      this.enquiryForm[_i].readOnly = false;

      _i = this.enquiryForm.findIndex(x => x.field == 'odUom');
      //this.enquiryForm[_i].disabled = false;
      this.enquiryForm[_i].isRequired = true;
      /*       this.enquiryForm[_i].value = '';
            this.enquiryForm[_i].text = ''; */
      this.enquiryForm[_i].readOnly = false;
      this.enquiryForm[_i].value = this.enquiryForm[_i].optionsList!.length > 0 ? this.enquiryForm[_i].optionsList?.filter(opt => opt.isDefault)![0].value! : '';
      this.enquiryForm[_i].text = this.enquiryForm[_i].optionsList!.length > 0 ? this.enquiryForm[_i].optionsList?.filter(opt => opt.isDefault)![0].text! : '';

      _i = this.enquiryForm.findIndex(x => x.field == 'id');
      this.enquiryForm[_i].disabled = false;
      this.enquiryForm[_i].isRequired = true;
      this.enquiryForm[_i].value = '';
      this.enquiryForm[_i].text = '';

      _i = this.enquiryForm.findIndex(x => x.field == 'idUom');
      this.enquiryForm[_i].disabled = false;
      this.enquiryForm[_i].isRequired = true;
      /* this.enquiryForm[_i].value = '';
      this.enquiryForm[_i].text = ''; */
      this.enquiryForm[_i].value = this.enquiryForm[_i].optionsList!.length > 0 ? this.enquiryForm[_i].optionsList?.filter(opt => opt.isDefault)![0].value! : '';
      this.enquiryForm[_i].text = this.enquiryForm[_i].optionsList!.length > 0 ? this.enquiryForm[_i].optionsList?.filter(opt => opt.isDefault)![0].text! : '';

      _i = this.enquiryForm.findIndex(x => x.field == 'wt');
      //this.enquiryForm[_i].disabled = false;
      this.enquiryForm[_i].isRequired = true;
      this.enquiryForm[_i].value = '';
      this.enquiryForm[_i].text = '';
      this.enquiryForm[_i].readOnly = false;

      _i = this.enquiryForm.findIndex(x => x.field == 'wtUom');
      //this.enquiryForm[_i].disabled = false;
      this.enquiryForm[_i].isRequired = true;
      /*  this.enquiryForm[_i].value = '';
       this.enquiryForm[_i].text = ''; */
      this.enquiryForm[_i].value = this.enquiryForm[_i].optionsList!.length > 0 ? this.enquiryForm[_i].optionsList?.filter(opt => opt.isDefault)![0].value! : '';
      this.enquiryForm[_i].text = this.enquiryForm[_i].optionsList!.length > 0 ? this.enquiryForm[_i].optionsList?.filter(opt => opt.isDefault)![0].text! : '';
      this.enquiryForm[_i].readOnly = false;

      // Turn ON
      _i = this.enquiryForm.findIndex(x => x.field == 'npsDescription');
      this.enquiryForm[_i].disabled = true;
      this.enquiryForm[_i].isRequired = false;
      this.enquiryForm[_i].value = '';
      this.enquiryForm[_i].text = '';
    }
  }

  onFormSelectListChanged(evt: DialogList) {
    /* if (evt.field == 'applicableNorms'){
      let _i: number = this.enquiryForm.findIndex(x => x.field == evt.field);
      this.enquiryForm[_i].value = evt.value;
      
      _i = this.enquiryForm.findIndex(x => x.field == 'normGrades');
      this.enquiryForm[_i].optionsList = new Array();
      this.enquiryForm[_i].optionsList = this.getNormGrades();
    } */

    /*     if (evt.field == 'normGrades'){
          let _i: number = this.enquiryForm.findIndex(x => x.field == evt.field);
          this.enquiryForm[_i].value = evt.value;
          
          _i = this.enquiryForm.findIndex(x => x.field == 'marketingGrades');
          this.enquiryForm[_i].optionsList = new Array();
          this.enquiryForm[_i].optionsList = this.getMarketingGrades();
        } */

  }

  onConfirmModalNps(evt: any) {
    // Check which unit system is selected
    let _i: number = this.enquiryForm.findIndex(x => x.field == 'unitSystem');
    let _uomSystem: string = this.enquiryForm[_i].value;
    if (_uomSystem == '') {
      this.teiasoftModalService.show('info', this.translate.instant('enquiryBook.add'), this.translate.instant('enquiryBook.selectUomSystem'), '', '');
      return;
    }

    // NPS DESCRIPTION
    _i = this.enquiryForm.findIndex(x => x.field == 'npsDescription');
    this.enquiryForm[_i].text = evt["npsDescription"];
    this.enquiryForm[_i].value = evt["npsScheduleId"];

    // OD
    _i = this.enquiryForm.findIndex(x => x.field == 'od');
    if (_uomSystem.toLowerCase() == 'metric') {
      this.enquiryForm[_i].text = evt["odMetric"];
      this.enquiryForm[_i].value = evt["odMetric"];
    } else {
      this.enquiryForm[_i].text = evt["odImperial"];
      this.enquiryForm[_i].value = evt["odImperial"];
    }

    // OD UOM
    _i = this.enquiryForm.findIndex(x => x.field == 'odUom');
    this.enquiryForm[_i].optionsList = new Array();
    this.enquiryForm[_i].optionsList = this.getUoms('odUoms');
    this.enquiryForm[_i].value = this.enquiryForm[_i].optionsList?.filter(opt => opt.isDefault)![0].value!;
    this.enquiryForm[_i].text = this.enquiryForm[_i].optionsList?.filter(opt => opt.isDefault)![0].text!;

    // WT
    _i = this.enquiryForm.findIndex(x => x.field == 'wt');
    if (_uomSystem.toLowerCase() == 'metric') {
      this.enquiryForm[_i].text = evt["wtMetric"];
      this.enquiryForm[_i].value = evt["wtMetric"];
    } else {
      this.enquiryForm[_i].text = evt["wtImperial"];
      this.enquiryForm[_i].value = evt["wtImperial"];
    }

    // WT UOM
    _i = this.enquiryForm.findIndex(x => x.field == 'wtUom');
    this.enquiryForm[_i].optionsList = new Array();
    this.enquiryForm[_i].optionsList = this.getUoms('wtUoms');
    this.enquiryForm[_i].value = this.enquiryForm[_i].optionsList?.filter(opt => opt.isDefault)![0].value!;
    this.enquiryForm[_i].text = this.enquiryForm[_i].optionsList?.filter(opt => opt.isDefault)![0].text!;

    this.showSelectNps = false;
    this.selectedNpsRow = new NpsAndSchedule();
    this.selectedNpsRow = evt;
    $('.teia-tt-toggle-pressed').focus(); // GBR MQBF-23
  }

  onCloseModalNps(evt: any) {
    // this.setWtOdIdNps('wtOdId');
    let _i: number = this.enquiryForm.findIndex(x => x.field == 'toolbarWtOdIdNps');
    this.enquiryForm![_i].toolbarButtonsList![0].state = 'pressed';
    this.enquiryForm![_i].toolbarButtonsList![1].state = '';
    this.showSelectNps = false;
    $('.teia-tt-toggle-pressed').focus(); // GBR MQBF-23
  }

  onGetOdataEntity(allColumns: GridColumn[]) {
    this.enquiryAllColumns = new Array();
    this.enquiryAllColumns = allColumns;
  }

  reloadEnquiry(enquiryNo: string) {
    this.editAndCreateVersionIfNecessary(enquiryNo).then(() => {
      this.refreshFullGrid();
    })
  }

  dialogButtonClick(evt: any) {
    const { action: _action, row: _obj } = parseGridActionEvent(evt);

  }

  /* RESET CONFIGURATION */
  resetConfiguration() {
    this.teiasoftModalService.show("confirm", "EnquiryBook", this.translate.instant('commons.confirmResetConfiguration'), '', 'confirmResetConfiguration');
  }

  /* MODAL CONFIRM */
  onConfirmModal(evt: TeiasoftModalReturnObject) {
    if (evt.closeFlag == 'confirmResetConfiguration') {
      this.globals.userLogged!.configuration = "";
      this.updateUserConfiguration();
    }

    if (evt.closeFlag == 'confirmCloseEnquiry') {
      this.enquiryClose(evt.parameter!);
    }

    /*     if (evt.closeFlag == 'confirmDuplicateEnquiry'){
          this.duplicateEnquiry(evt.parameter!);
        } */

    if (evt.closeFlag == 'confirmEditEnquiry') {
      this.checkItdcrResultsBeforeAction(evt.parameter, 'revision');
    }

    if (evt.closeFlag == 'confirmKeepItdcrResults' || evt.closeFlag == 'declineKeepItdcrResults') {
      const keepItdcrResults = evt.closeFlag == 'confirmKeepItdcrResults';
      const action = evt.parameter?.action as 'duplicate-save' | 'revision' | 'reopen';
      if (action == 'duplicate-save') {
        if (this.pendingDuplicateEnquiry && this.pendingDuplicateAction) {
          this.pendingDuplicateEnquiry.keepItdcrResults = keepItdcrResults;
          this.checkForSimilarEnquiriesAndCreateEnquiry(
            this.pendingDuplicateEnquiry,
            this.pendingDuplicateAction,
            this.pendingDuplicateAttachments || []
          );
        }
        this.pendingDuplicateEnquiry = null;
        this.pendingDuplicateAction = null;
        this.pendingDuplicateAttachments = null;
        return;
      }

      if (action == 'reopen') {
        if (this.pendingReopenRevision) {
          this.proceedWithReopenChoice(this.pendingReopenRevision, keepItdcrResults);
        }
        this.pendingReopenRevision = null;
        return;
      }

      const enquiryNo = evt.parameter?.enquiryNo;
      if (enquiryNo && action == 'revision') {
        this.proceedWithItdcrResultsChoice(enquiryNo, keepItdcrResults);
      }
    }

    if (evt.closeFlag == 'confirmDiscardEnquiryEdit') {
      this.discardEnquiryEdit(evt.parameter);
    }

    if (evt.closeFlag == 'confirmCloseEditingSession') {
      const enquiryNo = evt.parameter;
      this.subscriptions.add(this.backendService.checkEnquiryTotalMargin(enquiryNo, 'CloseEnquiryEditingSession').subscribe(res => {

        if (res.isTotalMarginOk) {
          this.closeEnquiryEditingSession(enquiryNo);
        }
        else {
          this.teiasoftModalService.show('confirm', this.translate.instant("enquiryBook.confirmCloseEditingSession"), this.translate.instant("enquiryBook.confirmMessageMarginCheckFailed"), enquiryNo, 'confirmCloseEditingSessionEnquiryWithIssues', true);
        }
      }));
    }

    if (evt.closeFlag == 'confirmCloseEditingSessionEnquiryWithIssues') {
      const enquiryNo = evt.parameter;
      const notes = evt.notes;
      this.closeEnquiryEditingSession(enquiryNo,
        {
          freeze: true,
          notes: notes
        });
    }

    if (evt.closeFlag == 'confirmChangeStatusEnquiryWithIssues') {
      const { enquiryNo, status } = evt.parameter;
      const notes = evt.notes;
      this.teiasoftLoader.start();
      this.backendService.changeMstOfferStatus(status, enquiryNo, { freeze: true, notes: notes }).subscribe(res => {
        this.teiasoftLoader.stop();
        this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
        this.showChangeStatus = false;
        this.refreshFullGrid();
      });
    }

    if (evt.closeFlag == 'confirmDeleteItem') {
      this.itemToDelete = evt.parameter!.split(" ")[0];
      setTimeout(() => this.itemToDelete = '---', 1000);
      //this.deleteItem(evt.parameter!.split(" ")[0], evt.parameter!.split(" ")[1]);
    }

    if (evt.closeFlag == 'confirmApplyEditInPlace') {
      this.globals.discardEditInPlace?.next(evt.parameter);
    }

    // if (evt.closeFlag == 'confirmReopenEnquiry') {
    //   this.teiasoftLoader.start();
    //   this.subscriptions.add(this.backendService.enquiryReOpen(evt.parameter).subscribe(
    //     {
    //       complete: () => { this.teiasoftLoader.stop(); this.refreshFullGrid(); }
    //     }
    //   ));
    // }

    if (evt.closeFlag == 'confirmDiscardItemEdit') {
      this.globals.discardItems?.next(evt.parameter);
    }

    /*  if(evt.closeFlag == 'discardEditInPlace'){
       this.globals.discardEditInPlace?.next(evt.parameter);
     }
 
     if(evt.closeFlag == 'confirmApplyEditInPlace'){
       this.globals.applyEditInPlace?.next(evt.parameter);
     } */
  }

  onSaveRevision(rs: RevisionSavePayload) {
    this.checkItdcrResultsBeforeReopen(rs);
  }

  /**
   * OPEN ENQUIRY EDIT FROM MODAL SUCCESS DUPLICATE
   * @param enquiryNo 
   */
  openEnquiryInEdit(enquiryNo: string) {
    this.showDuplicateEnquiry = false;
    this.teiasoftModalService.show('confirm', this.translate.instant("enquiryBook.editEnquiry"), this.translate.instant("enquiryBook.editEnquiryConfirmMessage"), enquiryNo, 'confirmEditEnquiry');
  }

  /**
   * CLOSE ENQUIRY FROM CLOSE ENQUIRY MODAL
   * @param enquiryNo 
   */
  closeEnquiry(data: CloseEnquiryData) {
    let _param: string = JSON.stringify(data);
    this.teiasoftModalService.show('confirm', this.translate.instant("enquiryBook.closeEnquiry"), this.translate.instant("enquiryBook.closeEnquiryConfirmMessage") + " <b>" + data.enquiryNo + "</b>?"
      , _param, 'confirmCloseEnquiry');
  }

  /* GRID CELL CLICK */
  onCellClick(cell: ClickedCell) {
    if (cell.colName?.toLowerCase() == 'attachments') {
      let _itemNo: string = JSON.parse(cell.row)["itemNo"];
      this.itemAttachments = new Array();
      this.itemAttachments = JSON.parse(JSON.stringify(this.enquiryItems.items?.find(x => x.itemNo == _itemNo)!.attachments!));
      this.showAttachments = true;
    }

    if (cell.colName == "NumberOfAttachments") {
      this.getEnquiryAttachments(cell.row["EnquiryNo"]);
    }

    if (cell.colName?.toLowerCase() == 'hascustomerspecialrequirements') {
      const enquiryNo: string = cell.row["EnquiryNo"];

      this.subscriptions.add(this.backendService.getEnquiryCustomerSpecialRequirements(enquiryNo).subscribe(res => {
        this.customerSpecialRequirements = res.customerSpecialRequirements;
        this.specialRequirementsReadOnly = true;
        this.showSpecialRequirements = true;
      }));
    }
  }

  getEnquiryAttachments(enquiryNo: string) {
    this.teiasoftLoader.start();
    this.backendService.getEnquiryAttachments(enquiryNo).subscribe(res => {
      this.teiasoftLoader.stop();
      this.enquiryAttachments = new Array();
      this.enquiryAttachments = JSON.parse(JSON.stringify(res["enquiryAttachments"]));
      this.showAttachments = true;
    });
  }

  onCloseAttachments(evt: any) {
    this.showAttachments = false;
    this.itemAttachments = new Array();
    this.enquiryAttachments = new Array();
  }

  onCloseQuotationModal(evt: any) {
    this.showDocumentTemplate = false;
    this.refreshFullGrid();

  }

  onActiveFiltersUpdate(activeFilters: ActiveFilter[]) {
    this.isDataFiltered = activeFilters.length > 0;
    this.buildButtonsList();
  }

  handleOpenQuotationTool() {
    this.showDocumentTemplateOptions = false;
    this.showDocumentTemplate = true;
  }

  handleUploadQuotation(evt: File) {
    this.teiasoftLoader.start();

    const reader = new FileReader();
    reader.onload = () => {
      const base64Content = (reader.result as string).split(',')[1]; // Get base64 content

      const payload = new QuotationConfigurationAndPdf();
      payload.isFinal = true;
      payload.quotationPdf = base64Content;
      payload.isExternalFile = true;

      this.subscriptions.add(this.backendService.saveQuotationConfigurationAndPdf(this.showDocumentTemplateEnquiryNo, payload).subscribe({
        next: () => {
          this.teiasoftToaster.show("success", this.translate.instant('quotation.uploadSuccess'));
          this.refreshFullGrid();
        },
        error: () => {
          this.teiasoftToaster.show("error", this.translate.instant('errors.failedToSaveQuotation'));
        },
        complete: () => { this.teiasoftLoader.stop(); this.showDocumentTemplateOptions = false; }
      }));
    };

    reader.readAsDataURL(evt);

  }

  onItemExtraCostsClick(item: EnquiryHeaderItem) {
    this.selectedExtraCostItem = item;
    this.showExtraCosts = true;
  }

  onItemDeliveryDatesClick(item: EnquiryHeaderItem) {
    this.selectedDeliveryDatesItem = this.enquiryItems.items?.find(i => i.itemNo == item.itemNo);
    this.showItemDeliveryDates = true;
  }

  getItemRowMinDeliveryDate(row: EnquiryHeaderItem): string {
    const item = this.enquiryItems.items?.find(i => i.itemNo === row.itemNo) as EnquiryHeaderItem;

    // Get minimum weeks value
    const minWeeks = item?.deliveryDatesCollection
      ?.map(dd => dd.deliveryNumberOfWeeksWithExtraLeadTime)
      .filter(weeks => typeof weeks === 'number' && weeks > 0)
      .reduce((min, current) => Math.min(min!, current!), Infinity);

    return minWeeks === Infinity ? '' : this.formatWeeks(minWeeks!);
  }

  formatWeeks(weeks: number): string {
    return `${weeks} week${weeks > 1 ? 's' : ''}`;
  }


  getItemRowDeliveryDatesCollection(row: EnquiryHeaderItem) {
    const item = this.enquiryItems.items?.find(i => i.itemNo == row.itemNo) as EnquiryHeaderItem;

    return item?.deliveryDatesCollection || [];
  }

  formatDate(date: number) {
    return this.utils.formatDate(date);
  }


  formatWeekDate(dateMillis: number) {
    const date = new Date(dateMillis);
    if (isNaN(date.getTime())) return '';

    // Get full year and last two digits
    const fullYear = date.getFullYear();
    const yearSuffix = fullYear.toString().slice(-2);

    const firstJan = new Date(fullYear, 0, 1);
    const diffDays = Math.floor((date.getTime() - firstJan.getTime()) / (1000 * 60 * 60 * 24));
    const weekNumber = Math.ceil((diffDays + firstJan.getDay() + 1) / 7);

    return `W${weekNumber}-${yearSuffix}`;
  }

  onSkipCheckSimilarEnquiries() {
    this.onAbortCreation();

    if (this.pendingEnquiry && this.pendingAction) {
      // Resume the original flow
      this.createEnquiry(this.pendingEnquiry, this.pendingAction, this.pendingAttachments || []);

      // Clear pending values
      this.pendingEnquiry = null;
      this.pendingAction = null;
      this.pendingAttachments = null;

    }
  }

  onAbortCreation() {
    this.showSimilarEnquiriesModal = false;
    this.similarEnquiriesEnquiryNo = null;
  }

  onSearchForSimilarEnquiries(enquiryNo: string) {
    this.similarEnquiriesEnquiryNo = enquiryNo;
    this.showSimilarEnquiriesModal = true;
  }

  onCompleteItdcr($event: any) {
    this.showOpenIDTCR = false;
    this.refreshFullGrid();

    if ($event) {
      this.router.navigate(['/view-itdcrs']);
    }
  }

  onCloseItdcrViewer() {
    const expandedEnquiryNo = this.expandedEnquiryNo;

    this.showItdcrViewerModal = false;
    this.itdcrViewerNo = '';
    this.itdcrViewerShowHistory = false;
    this.refreshFullGrid();

    if (expandedEnquiryNo) {
      this.getItemsByEnquiryNo(expandedEnquiryNo);
    }
  }

  onSaveSpecialeRequirements($event: CustomerSpecialRequirement[]) {
    if ($event) {
      this.customerSpecialRequirements = $event;
      this.showSpecialRequirements = false;
      this.updateSpecialRequirementsButtonText();
    }
  }

}
